﻿import {
    clearCommentDeleteError,
    clearCommentFormError,
    clearCommentsError,
    clearReactionError,
    clearReactionsError,
    showCommentDeleteError,
    showCommentFormError,
    showCommentsError,
    showReactionError,
    showReactionsError,
} from './errors';

import {
    trapModalFocus,
} from './focus';

import {
    buildReactionDetailsUrl,
    reactionDefinitions,
} from './reactions-utils';

import {
    formatCommentText,
    formatLikeText,
    formatReactionText,
    getPhotoData,
    numberFormatter,
    parseCount,
    parseJsonData,
    setOptionalText,
} from './utils';

import {
    addCommentToCache,
    clearPhotoReactionCache,
    getCachedComments,
    getReactionCacheKey,
    reactionMembersCache,
    removeCommentFromCache,
    setCachedComments,
    updateCommentInCache,
} from './cache';

import {
    clearPreloadedPhotos,
    preloadAdjacentPhotos,
} from './preload';

import {
    createPhotoSlideshow,
} from './slideshow';

import { initializePhotoManagement } from './management';

let activeModal = null;
let disposeModal = () => {};

const initializeFestivalPhotoModal = () => {
    const modal = document.querySelector(
        '#festival-photo-modal'
    );

    if (modal === activeModal) return;
    disposeModal();
    activeModal = modal;
    const lifecycle = new AbortController();
    const listenDocument = (type, callback) => document.addEventListener(type, callback, { signal: lifecycle.signal });
    const listenWindow = (type, callback) => window.addEventListener(type, callback, { signal: lifecycle.signal });
    disposeModal = () => lifecycle.abort();

    if (!modal) {
        return;
    }

    // Escape page stacking contexts so the viewer also covers mobile navigation.
    const modalHome = document.createComment('festival-photo-modal');
    modal.before(modalHome);
    document.body.append(modal);

	if (!modal.hasAttribute('tabindex')) {
    modal.tabIndex = -1;
}
	
    let triggers = Array.from(
    document.querySelectorAll(
        '.festival-photo-lightbox-trigger'
    )
);

const refreshPhotoTriggers = () => {
    const available = Array.from(
        document.querySelectorAll(
            '.festival-photo-lightbox-trigger'
        )
    );

    triggers = [...new Map(available.map((trigger) => [trigger.dataset.photoId, trigger])).values()];

    clearPreloadedPhotos();
};
refreshPhotoTriggers();
    /*
    |--------------------------------------------------------------------------
    | Main photo modal elements
    |--------------------------------------------------------------------------
    */

    const image = modal.querySelector(
        '[data-photo-modal-image]'
    );
	
	const tagOverlay = modal.querySelector(
    '[data-photo-modal-tag-overlay]'
);
	const tagToggleButton =
    modal.querySelector(
        '[data-photo-modal-tag-toggle]'
    );

const tagPlacementMarker = modal.querySelector(
    '[data-photo-modal-tag-placement]'
);

    const loading = modal.querySelector(
        '[data-photo-modal-loading]'
    );

    const uploader = modal.querySelector(
        '[data-photo-modal-uploader]'
    );

    const details = modal.querySelector(
        '[data-photo-modal-details]'
    );

    const detailsWrapper = modal.querySelector(
        '[data-photo-modal-details-wrapper]'
    );

    const takenAt = modal.querySelector(
        '[data-photo-modal-taken]'
    );

    const takenWrapper = modal.querySelector(
        '[data-photo-modal-taken-wrapper]'
    );

    const caption = modal.querySelector(
        '[data-photo-modal-caption]'
    );

    const captionWrapper = modal.querySelector(
        '[data-photo-modal-caption-wrapper]'
    );

    const position = modal.querySelector(
        '[data-photo-modal-position]'
    );

    const previousButton = modal.querySelector(
        '[data-photo-modal-previous]'
    );

    const nextButton = modal.querySelector(
        '[data-photo-modal-next]'
    );

    const closeButtons = modal.querySelectorAll(
        '[data-photo-modal-close]'
    );
	
	const slideshowButton =
    modal.querySelector(
        '[data-photo-modal-slideshow]'
    );
	
	const slideshowProgress =
    modal.querySelector(
        '[data-photo-modal-slideshow-progress]'
    );

    /*
    |--------------------------------------------------------------------------
    | Sidebar tabs
    |--------------------------------------------------------------------------
    */

    const sidebarTabs = Array.from(
        modal.querySelectorAll(
            '[data-photo-modal-tab]'
        )
    );

    const sidebarPanels = Array.from(
        modal.querySelectorAll(
            '[data-photo-modal-panel]'
        )
    );
	
	/*
|--------------------------------------------------------------------------
| Photo tag elements
|--------------------------------------------------------------------------
*/

const tagCount = modal.querySelector(
    '[data-photo-modal-tag-count]'
);

const tagOpenButton = modal.querySelector(
    '[data-photo-modal-tag-open]'
);

const tagsLoading = modal.querySelector(
    '[data-photo-modal-tags-loading]'
);

const tagsError = modal.querySelector(
    '[data-photo-modal-tags-error]'
);

const tagsEmpty = modal.querySelector(
    '[data-photo-modal-tags-empty]'
);

const tagsList = modal.querySelector(
    '[data-photo-modal-tags-list]'
);

const tagPicker = modal.querySelector(
    '[data-photo-modal-tag-picker]'
);

const tagCloseButton = modal.querySelector(
    '[data-photo-modal-tag-close]'
);

const tagSearch = modal.querySelector(
    '[data-photo-modal-tag-search]'
);

const tagMembersLoading = modal.querySelector(
    '[data-photo-modal-tag-members-loading]'
);

const tagMembersError = modal.querySelector(
    '[data-photo-modal-tag-members-error]'
);

const tagMembersEmpty = modal.querySelector(
    '[data-photo-modal-tag-members-empty]'
);

const tagMembersList = modal.querySelector(
    '[data-photo-modal-tag-members-list]'
);

    /*
|--------------------------------------------------------------------------
| Reaction elements
|--------------------------------------------------------------------------
*/

const reactionForm = modal.querySelector(
    '[data-photo-modal-reaction-form]'
);

const reactionCount = modal.querySelector(
    '[data-photo-modal-reaction-count]'
);

const reactionSummary = modal.querySelector(
    '[data-photo-modal-reaction-summary]'
);

const selectedReactionMessage = modal.querySelector(
    '[data-photo-modal-selected-reaction]'
);

const reactionChoiceButtons = Array.from(
    modal.querySelectorAll(
        '[data-photo-reaction-choice]'
    )
);

const loginLink = modal.querySelector(
    '[data-photo-modal-login-link]'
);

const reactionError = modal.querySelector(
    '[data-photo-modal-reaction-error]'
);
	
	const reactionFilters = modal.querySelector(
    '[data-photo-modal-reaction-filters]'
);
	
	const createReactionMemberElement = (
    reaction
) => {
    const article =
        document.createElement(
            'article'
        );

    article.className =
        'flex items-center justify-between gap-3 rounded-xl border border-zinc-200 bg-white p-3 dark:border-white/10 dark:bg-slate-950/40';

    article.dataset
        .photoReactionMemberId =
        String(reaction.id);

    const memberArea =
        document.createElement('div');

    memberArea.className =
        'flex min-w-0 items-center gap-3';

    const avatar =
    reaction.member?.profile_photo_url
        ? document.createElement('img')
        : document.createElement('div');

if (
    avatar instanceof HTMLImageElement
    && reaction.member?.profile_photo_url
) {
    avatar.src =
        reaction.member.profile_photo_url;

    avatar.alt =
        `${reaction.member?.name || 'Member'} profile photo`;

    avatar.loading = 'lazy';

    avatar.className =
        'h-10 w-10 shrink-0 rounded-full object-cover ring-1 ring-white/10';
} else {
    avatar.className =
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cyan-50 text-xs font-black text-cyan-700 ring-1 ring-cyan-200 dark:bg-cyan-400/15 dark:text-cyan-200 dark:ring-white/10';

    avatar.textContent =
        reaction.member?.initials
        || '?';
}

    const memberText =
        document.createElement('div');

    memberText.className =
        'min-w-0';

    const memberName =
        reaction.member?.profile_url
            ? document.createElement(
                'a'
            )
            : document.createElement(
                'span'
            );

    memberName.className =
        'block truncate text-sm font-black text-zinc-950 dark:text-white';

    memberName.textContent =
        reaction.member?.name
        || 'FestFriends member';

    if (
        memberName instanceof
            HTMLAnchorElement
        && reaction.member?.profile_url
    ) {
        memberName.href =
            reaction.member.profile_url;

        memberName.classList.add(
            'transition',
            'hover:text-cyan-200'
        );
    }

    const metadata =
        document.createElement('p');

    metadata.className =
        'mt-0.5 text-xs text-slate-500';

    metadata.textContent =
        reaction.created_at_human
        || '';

    memberText.appendChild(
        memberName
    );

    memberText.appendChild(
        metadata
    );

    memberArea.appendChild(
        avatar
    );

    memberArea.appendChild(
        memberText
    );

    const reactionBadge =
        document.createElement('span');

    reactionBadge.className =
        'flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-zinc-200 bg-zinc-50 text-xl dark:border-white/10 dark:bg-white/5';

    reactionBadge.textContent =
        reaction.reaction_emoji
        || '';

    reactionBadge.title =
        reaction.reaction_label
        || 'Reaction';

    article.appendChild(
        memberArea
    );

    article.appendChild(
        reactionBadge
    );

    return article;
};
	
	const renderReactionMembers = (
    reactions,
    append = false
) => {
    if (!reactionsList) {
        return;
    }

    if (!append) {
        reactionsList.innerHTML = '';
    }

    reactions.forEach((reaction) => {
        reactionsList.appendChild(
            createReactionMemberElement(
                reaction
            )
        );
    });

    const hasMembers =
        reactionsList.children.length > 0;

    reactionsEmpty?.classList.toggle(
        'hidden',
        hasMembers
    );
};

const renderCachedReactionMembers = (
    cachedData
) => {
    renderReactionMembers(
        cachedData.reactions ?? []
    );

    reactionsNextPageUrl =
        cachedData.nextPageUrl
        || null;

    reactionsMoreButton
        ?.classList
        .toggle(
            'hidden',
            !cachedData.hasMorePages
        );

    renderReactionFilters(
        cachedData.reactionCounts ?? {},
        parseCount(
            cachedData.reactionCount
        )
    );

    const activePhoto = getPhotoData(
        triggers[currentIndex]
    );

    loadedReactionsPhotoId =
        activePhoto.id;

    clearReactionsError(
    reactionsError
);
};
	const loadReactionMembers = async (
    url,
    append = false
) => {
    if (
        !reactionsList
        || !reactionsLoading
        || !reactionsMoreButton
    ) {
        return;
    }

    if (!url) {
        showReactionsError(
reactionsError,
            'Reaction details are unavailable for this photo.'
        );

        return;
    }

    const requestNumber =
        ++reactionsRequestNumber;

    clearReactionsError(
    reactionsError
);

    if (!append) {
        reactionsList.innerHTML = '';

        reactionsEmpty?.classList.add(
            'hidden'
        );

        reactionsLoading.classList.remove(
            'hidden'
        );

        reactionsLoading.classList.add(
            'flex'
        );
    } else {
        reactionsMoreButton.disabled =
            true;

        reactionsMoreButton.textContent =
            'Loading...';
    }

    try {
        const response = await fetch(
            url,
            {
                method: 'GET',

                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',
                },
            }
        );

        const data =
            await response.json();

        if (!response.ok) {
            throw new Error(
                data.message
                || 'Reaction details could not be loaded.'
            );
        }

        if (
            requestNumber
            !== reactionsRequestNumber
        ) {
            return;
        }

        const cacheKey =
    getCurrentReactionCacheKey();

const existingCache =
    reactionMembersCache.get(
        cacheKey
    );

const receivedReactions =
    Array.isArray(data.reactions)
        ? data.reactions
        : [];

const cachedReactions =
    append && existingCache
        ? [
            ...existingCache.reactions,
            ...receivedReactions,
        ]
        : receivedReactions;

renderReactionMembers(
    receivedReactions,
    append
);

reactionsNextPageUrl =
    data.next_page_url
    || null;

        reactionsMoreButton
            .classList
            .toggle(
                'hidden',
                !data.has_more_pages
            );

        const reactionCounts =
            data.reaction_counts
            ?? {};

        renderReactionFilters(
            reactionCounts,
            parseCount(
                data.reaction_count
            )
        );

reactionMembersCache.set(
    cacheKey,
    {
        reactions:
            cachedReactions,

        nextPageUrl:
            reactionsNextPageUrl,

        hasMorePages:
            Boolean(
                data.has_more_pages
            ),

        reactionCounts,

        reactionCount:
            parseCount(
                data.reaction_count
            ),
    }
);

        const activePhoto =
            getPhotoData(
                triggers[currentIndex]
            );

        loadedReactionsPhotoId =
            activePhoto.id;
    } catch (error) {
        if (
            requestNumber
            !== reactionsRequestNumber
        ) {
            return;
        }

        showReactionsError(
    reactionsError,
    error.message
    || 'Reaction details could not be loaded.'
);
    } finally {
        if (
            requestNumber
            === reactionsRequestNumber
        ) {
            reactionsLoading.classList.add(
                'hidden'
            );

            reactionsLoading.classList.remove(
                'flex'
            );

            reactionsMoreButton.disabled =
                false;

            reactionsMoreButton.textContent =
                'Load More Members';
        }
    }
};

			const loadCurrentPhotoReactions = (
    forceReload = false
) => {
    const activePhoto = getPhotoData(
        triggers[currentIndex]
    );

    if (
        !forceReload
        && loadedReactionsPhotoId
            === activePhoto.id
    ) {
        return;
    }

    const cacheKey =
        getReactionCacheKey(
            activePhoto.id,
            activeReactionFilter
        );

    const cachedData =
        reactionMembersCache.get(
            cacheKey
        );

    if (!forceReload && cachedData) {
        renderCachedReactionMembers(
            cachedData
        );

        return;
    }

    reactionsNextPageUrl = null;

    const url =
        buildReactionDetailsUrl(
            activePhoto.reactionsUrl,
            activeReactionFilter
        );

    loadReactionMembers(url);
};
			
const reactionsLoading = modal.querySelector(
    '[data-photo-modal-reactions-loading]'
);

const reactionsError = modal.querySelector(
    '[data-photo-modal-reactions-error]'
);

const reactionsList = modal.querySelector(
    '[data-photo-modal-reactions-list]'
);

const reactionsEmpty = modal.querySelector(
    '[data-photo-modal-reactions-empty]'
);

const reactionsMoreButton = modal.querySelector(
    '[data-photo-modal-reactions-more]'
);

    /*
    |--------------------------------------------------------------------------
    | Comment elements
    |--------------------------------------------------------------------------
    */

    const commentsLoading = modal.querySelector(
        '[data-photo-modal-comments-loading]'
    );

    const commentsError = modal.querySelector(
        '[data-photo-modal-comments-error]'
    );

    const commentsList = modal.querySelector(
        '[data-photo-modal-comments-list]'
    );

    const commentsEmpty = modal.querySelector(
        '[data-photo-modal-comments-empty]'
    );

    const commentsMoreButton = modal.querySelector(
        '[data-photo-modal-comments-more]'
    );

    const modalCommentCount = modal.querySelector(
        '[data-photo-modal-comment-count]'
    );

    const commentForm = modal.querySelector(
        '[data-photo-modal-comment-form]'
    );

    const commentBody = modal.querySelector(
        '[data-photo-modal-comment-body]'
    );

    const commentSubmitButton = modal.querySelector(
        '[data-photo-modal-comment-submit]'
    );

    const commentFormError = modal.querySelector(
        '[data-photo-modal-comment-form-error]'
    );

    const commentLoginLink = modal.querySelector(
        '[data-photo-modal-comment-login]'
    );

	const mentionResults =
    modal.querySelector(
        '[data-photo-modal-mention-results]'
    );

	const mentionWrapper =
    modal.querySelector(
        '[data-photo-modal-mention-wrapper]'
    );

const mentionWrapperHome =
    mentionWrapper?.parentNode
    ?? null;

const mentionWrapperHomeNextSibling =
    mentionWrapper?.nextSibling
    ?? null;

    /*
    |--------------------------------------------------------------------------
    | Comment delete modal elements
    |--------------------------------------------------------------------------
    */

    const commentDeleteModal = document.querySelector(
        '#festival-photo-comment-delete-modal'
    );

    const commentDeletePreview =
        commentDeleteModal?.querySelector(
            '[data-photo-comment-delete-preview]'
        );

    const commentDeleteConfirmButton =
        commentDeleteModal?.querySelector(
            '[data-photo-comment-delete-confirm]'
        );

    const commentDeleteCancelButtons =
        commentDeleteModal?.querySelectorAll(
            '[data-photo-comment-delete-cancel]'
        ) ?? [];

    const commentDeleteError =
        commentDeleteModal?.querySelector(
            '[data-photo-comment-delete-error]'
        );

    /*
    |--------------------------------------------------------------------------
    | Shared state
    |--------------------------------------------------------------------------
    */

    const csrfToken =
        document.querySelector(
            'meta[name="csrf-token"]'
        )?.getAttribute('content')
        || reactionForm
            ?.querySelector(
                'input[name="_token"]'
            )
            ?.value
        || commentForm
            ?.querySelector(
                'input[name="_token"]'
            )
            ?.value
        || '';

	

    let currentIndex = 0;

    let previousActiveElement = null;

let swipeStartX = null;

let swipeStartY = null;

let swipePointerId = null;

let swipeStartedOnPhoto = false;

		let reactionsNextPageUrl = null;

let reactionsRequestNumber = 0;

let activeReactionFilter = null;

let loadedReactionsPhotoId = null;

		
    let commentsNextPageUrl = null;

let commentsRequestNumber = 0;

let loadedCommentsPhotoId = null;

let tagsRequestNumber = 0;

let loadedTagsPhotoId = null;

let currentTagStoreUrl = null;

let currentEligibleMembersUrl = null;

let tagMembersRequestNumber = 0;

let tagSearchTimeoutId = null;

let pendingTagPosition = null;

let placementMode = false;

let currentPhotoTags = [];

let photoTagsVisible = true;


    let pendingCommentDeleteButton = null;

	let activeCommentEditArticle = null;

	let mentionSearchTimeoutId = null;

let mentionSearchRequestNumber = 0;

let mentionMembers = [];

let activeMentionIndex = -1;

let activeMentionRange = null;

let activeMentionInput =
    commentBody;
	
    /*
    |--------------------------------------------------------------------------
    | General helpers
    |--------------------------------------------------------------------------
    */

const getMentionInput = () =>
    activeMentionInput
    ?? commentBody;

const restoreMainMentionInput = () => {
    closeMentionResults();

    activeMentionInput =
        commentBody;

    if (
        mentionWrapper
        && mentionWrapperHome
    ) {
        mentionWrapperHome.insertBefore(
            mentionWrapper,
            mentionWrapperHomeNextSibling
        );
    }
};

const closeMentionResults = () => {
    if (mentionSearchTimeoutId !== null) {
        window.clearTimeout(
            mentionSearchTimeoutId
        );

        mentionSearchTimeoutId = null;
    }

    mentionSearchRequestNumber++;

    mentionMembers = [];

    activeMentionIndex = -1;

    activeMentionRange = null;

    if (mentionResults) {
        mentionResults.innerHTML = '';

        mentionResults.classList.add(
            'hidden'
        );
    }

    const mentionInput =
    getMentionInput();

mentionInput?.removeAttribute(
    'aria-activedescendant'
);

mentionInput?.setAttribute(
    'aria-expanded',
    'false'
);
};

const getActiveMention = () => {
    if (!commentBody) {
        return null;
    }

    const caretPosition =
        commentBody.selectionStart;

    if (
        caretPosition === null
        || caretPosition
            !== commentBody.selectionEnd
    ) {
        return null;
    }

    const textBeforeCaret =
        commentBody.value.slice(
            0,
            caretPosition
        );

    /*
     * An @mention must begin at the start of
     * the comment or after whitespace or an
     * opening punctuation character.
     */
    const match =
        textBeforeCaret.match(
            /(?:^|[\s([{])@([A-Za-z0-9_]{1,30})$/
        );

    if (!match) {
        return null;
    }

    const matchedText =
        match[0];

    const atOffset =
        matchedText.lastIndexOf('@');

    const start =
        textBeforeCaret.length
        - matchedText.length
        + atOffset;

    return {
        query:
            match[1],

        start,

        end:
            caretPosition,
    };
};

const setActiveMentionIndex = (
    index
) => {
    if (
        !mentionResults
        || mentionMembers.length === 0
    ) {
        activeMentionIndex = -1;

        return;
    }

    const normalizedIndex =
        (
            index
            + mentionMembers.length
        )
        % mentionMembers.length;

    activeMentionIndex =
        normalizedIndex;

    const buttons = Array.from(
        mentionResults.querySelectorAll(
            '[data-photo-mention-result]'
        )
    );

    buttons.forEach(
        (button, buttonIndex) => {
            const selected =
                buttonIndex
                === normalizedIndex;

            button.classList.toggle(
                'bg-cyan-400/15',
                selected
            );

            button.classList.toggle(
                'text-white',
                selected
            );

            button.setAttribute(
                'aria-selected',
                selected
                    ? 'true'
                    : 'false'
            );
        }
    );

    const activeButton =
        buttons[normalizedIndex];

    if (activeButton) {
        commentBody?.setAttribute(
            'aria-activedescendant',
            activeButton.id
        );

        activeButton.scrollIntoView({
            block:
                'nearest',
        });
    }
};

const insertMentionMember = (
    member
) => {
    if (
        !commentBody
        || !activeMentionRange
        || !member?.username
    ) {
        return;
    }

    const before =
        commentBody.value.slice(
            0,
            activeMentionRange.start
        );

    const after =
        commentBody.value.slice(
            activeMentionRange.end
        );

    const replacement =
        `@${member.username} `;

    commentBody.value =
        before
        + replacement
        + after;

    const caretPosition =
        before.length
        + replacement.length;

    closeMentionResults();

    commentBody.focus();

    commentBody.setSelectionRange(
        caretPosition,
        caretPosition
    );
};

const renderMentionResults = (
    members
) => {
    if (!mentionResults) {
        return;
    }

    mentionResults.innerHTML = '';

    mentionMembers =
        Array.isArray(members)
            ? members.filter(
                (member) =>
                    Boolean(
                        member?.username
                    )
            )
            : [];

    if (mentionMembers.length === 0) {
        const empty =
            document.createElement('p');

        empty.className =
            'px-4 py-3 text-sm font-semibold text-zinc-600 dark:text-slate-400';

        empty.textContent =
            'No matching festival members.';

        mentionResults.appendChild(
            empty
        );

        mentionResults.classList.remove(
            'hidden'
        );

        commentBody?.setAttribute(
            'aria-expanded',
            'true'
        );

        activeMentionIndex = -1;

        return;
    }

    mentionMembers.forEach(
        (member, index) => {
            const button =
                document.createElement(
                    'button'
                );

            button.type = 'button';

            button.id =
                `photo-mention-result-${index}`;

            button.dataset
                .photoMentionResult =
                String(index);

            button.className =
                'flex w-full items-center gap-3 px-4 py-3 text-left text-zinc-700 transition hover:bg-cyan-50 hover:text-cyan-800 dark:text-slate-200 dark:hover:bg-cyan-400/15 dark:hover:text-white';

            button.setAttribute(
                'role',
                'option'
            );

            button.setAttribute(
                'aria-selected',
                'false'
            );

            const avatar =
                member.profile_photo_url
                    ? document.createElement(
                        'img'
                    )
                    : document.createElement(
                        'span'
                    );

            if (
                avatar instanceof
                    HTMLImageElement
            ) {
                avatar.src =
                    member
                        .profile_photo_url;

                avatar.alt = '';

                avatar.loading =
                    'lazy';

                avatar.className =
                    'h-9 w-9 shrink-0 rounded-full object-cover ring-1 ring-white/10';
            } else {
                avatar.className =
                    'flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cyan-50 text-xs font-black text-cyan-700 ring-1 ring-cyan-200 dark:bg-cyan-400/15 dark:text-cyan-200 dark:ring-white/10';

                avatar.textContent =
                    member.initials
                    || '?';
            }

            const text =
                document.createElement(
                    'span'
                );

            text.className =
                'min-w-0';

            const name =
                document.createElement(
                    'span'
                );

            name.className =
                'block truncate text-sm font-black';

            name.textContent =
                member.name
                || member.username;

            const username =
                document.createElement(
                    'span'
                );

            username.className =
                'block truncate text-xs font-semibold text-slate-500';

            username.textContent =
                `@${member.username}`;

            text.appendChild(name);

            text.appendChild(username);

            button.appendChild(avatar);

            button.appendChild(text);

            button.addEventListener(
                'mousedown',
                (event) => {
                    /*
                     * Prevent the textarea from
                     * losing its caret position.
                     */
                    event.preventDefault();
                }
            );

            button.addEventListener(
                'click',
                () => {
                    insertMentionMember(
                        member
                    );
                }
            );

            mentionResults.appendChild(
                button
            );
        }
    );

    mentionResults.classList.remove(
        'hidden'
    );

    commentBody?.setAttribute(
        'aria-expanded',
        'true'
    );

    setActiveMentionIndex(0);
};

const searchMentionMembers =
    async (
        url,
        query,
        requestNumber
    ) => {
        try {
            const searchUrl =
                new URL(
                    url,
                    window.location.origin
                );

            searchUrl.searchParams.set(
                'q',
                query
            );

            const response =
                await fetch(
                    searchUrl.toString(),
                    {
                        method:
                            'GET',

                        credentials:
                            'same-origin',

                        headers: {
                            Accept:
                                'application/json',

                            'X-Requested-With':
                                'XMLHttpRequest',
                        },
                    }
                );

            if (
                requestNumber
                !== mentionSearchRequestNumber
            ) {
                return;
            }

            if (!response.ok) {
                closeMentionResults();

                return;
            }

            const data =
                await response.json();

            if (
                requestNumber
                !== mentionSearchRequestNumber
            ) {
                return;
            }

            renderMentionResults(
                data.members
            );
        } catch (error) {
            if (
                requestNumber
                === mentionSearchRequestNumber
            ) {
                closeMentionResults();
            }
        }
    };

const scheduleMentionSearch = () => {
    if (!commentBody) {
        return;
    }

    const mention =
        getActiveMention();

    if (!mention) {
        closeMentionResults();

        return;
    }

    const activePhoto =
        getPhotoData(
            triggers[currentIndex]
        );

    if (
        !activePhoto
            .mentionMembersUrl
    ) {
        closeMentionResults();

        return;
    }

    activeMentionRange = {
        start:
            mention.start,

        end:
            mention.end,
    };

    if (mentionSearchTimeoutId !== null) {
        window.clearTimeout(
            mentionSearchTimeoutId
        );
    }

    const requestNumber =
        ++mentionSearchRequestNumber;

    mentionSearchTimeoutId =
        window.setTimeout(
            () => {
                mentionSearchTimeoutId =
                    null;

                searchMentionMembers(
                    activePhoto
                        .mentionMembersUrl,
                    mention.query,
                    requestNumber
                );
            },
            250
        );
};

const getCurrentReactionCacheKey = () => {
    const activePhoto = getPhotoData(
        triggers[currentIndex]
    );

    return getReactionCacheKey(
        activePhoto.id,
        activeReactionFilter
    );
};


    const activateSidebarTab = (
        tabName,
        focusTab = false
    ) => {
        sidebarTabs.forEach((tab) => {
            const selected =
                tab.dataset.photoModalTab
                === tabName;

            tab.setAttribute(
                'aria-selected',
                selected ? 'true' : 'false'
            );

            tab.tabIndex = selected ? 0 : -1;

            tab.classList.toggle(
                'bg-cyan-300',
                selected
            );

            tab.classList.toggle(
                'text-slate-950',
                selected
            );

            tab.classList.toggle(
                'text-slate-400',
                !selected
            );

            if (selected && focusTab) {
                tab.focus();
            }
        });

        sidebarPanels.forEach((panel) => {
            const selected =
                panel.dataset.photoModalPanel
                === tabName;

            panel.hidden = !selected;

            panel.classList.toggle(
                'hidden',
                !selected
            );
        });
		
		if (
    tabName === 'reactions'
    || tabName === 'comments'
) {
    slideshow.pause();
}

if (tabName === 'reactions') {
    loadCurrentPhotoReactions();
}

if (tabName === 'comments') {
    loadCurrentPhotoComments();
}

    };





    /*
    |--------------------------------------------------------------------------
    | Delete-modal helpers
    |--------------------------------------------------------------------------
    */

    

    const openCommentDeleteModal = (
        deleteButton
    ) => {

		slideshow.pause();

        if (!commentDeleteModal) {
            return;
        }

        pendingCommentDeleteButton =
            deleteButton;

        clearCommentDeleteError(
    commentDeleteError
);

        if (commentDeletePreview) {
            commentDeletePreview.textContent =
                deleteButton.dataset
                    .photoCommentBody
                || 'This comment';
        }

        commentDeleteModal.classList.remove(
            'hidden'
        );

        commentDeleteConfirmButton?.focus();
    };

    const closeCommentDeleteModal = () => {
        if (!commentDeleteModal) {
            return;
        }

        commentDeleteModal.classList.add(
            'hidden'
        );

        clearCommentDeleteError(
    commentDeleteError
);

        pendingCommentDeleteButton = null;
    };

    /*
    |--------------------------------------------------------------------------
    | Like rendering
    |--------------------------------------------------------------------------
    */
const renderReactionFilters = (
    reactionCounts,
    reactionCount
) => {
    if (!reactionFilters) {
        return;
    }

    reactionFilters.innerHTML = '';

    reactionFilters.className =
        'grid grid-cols-3 gap-3';

    const filterDefinitions = [
        ...Object.entries(
            reactionDefinitions
        ).map(
            ([reaction, definition]) => ({
                reaction,
                label:
                    definition.label,

                emoji:
                    definition.emoji,

                count:
                    parseCount(
                        reactionCounts[
                            reaction
                        ]
                    ),
            })
        ),

        {
            reaction: null,
            label: 'All',
            emoji: '',
            count:
                parseCount(
                    reactionCount
                ),
        },
    ];

    filterDefinitions.forEach(
        (filter) => {
            const button =
                document.createElement(
                    'button'
                );

            button.type = 'button';

            button.dataset
                .photoReactionFilter =
                filter.reaction ?? '';

            const selected =
                activeReactionFilter
                === filter.reaction;

            button.className = [
                'flex min-h-24 w-full min-w-0 flex-col items-center justify-center gap-1 rounded-2xl border px-2 py-3 text-center transition disabled:cursor-not-allowed disabled:opacity-50',

                selected
                    ? 'border-cyan-300 bg-cyan-300 text-slate-950 shadow-lg shadow-cyan-950/20'
                    : 'border-white/10 bg-white/5 text-slate-300 hover:border-cyan-400/30 hover:bg-cyan-400/10 hover:text-white',
            ].join(' ');

            button.setAttribute(
                'aria-pressed',
                selected
                    ? 'true'
                    : 'false'
            );

            if (
                filter.reaction
                && filter.count === 0
            ) {
                button.disabled = true;
            }

            const icon =
                document.createElement(
                    'span'
                );

            icon.className =
                'flex h-8 items-center justify-center text-2xl leading-none';

            icon.textContent =
                filter.emoji || '✦';

            const label =
                document.createElement(
                    'span'
                );

            label.className =
                'max-w-full text-sm font-black leading-tight';

            label.textContent =
                filter.label;

            const count =
                document.createElement(
                    'span'
                );

            count.className = selected
                ? 'text-xs font-bold text-slate-800'
                : 'text-xs font-bold text-slate-500';

            count.textContent =
                numberFormatter.format(
                    filter.count
                );

            button.appendChild(icon);

            button.appendChild(label);

            button.appendChild(count);

            reactionFilters.appendChild(
                button
            );
        }
    );
};
		
    const renderReactionControls = (
    photo
) => {
    clearReactionError(
    reactionError
);

    if (reactionCount) {
        reactionCount.textContent =
            formatReactionText(
                photo.reactionCount
            );
    }

    if (reactionSummary) {
        reactionSummary.innerHTML = '';

        Object.entries(
            photo.reactionCounts
        )
            .filter(
                ([, count]) =>
                    parseCount(count) > 0
            )
            .forEach(
                ([reaction, count]) => {
                    const definition =
                        reactionDefinitions[
                            reaction
                        ];

                    if (!definition) {
                        return;
                    }

                    const badge =
                        document.createElement(
                            'span'
                        );

                    badge.className =
                        'flex h-8 min-w-8 items-center justify-center rounded-full border-2 border-slate-900 bg-slate-800 px-1 text-sm shadow';

                    badge.textContent =
                        definition.emoji;

                    badge.title =
                        `${definition.label}: ${numberFormatter.format(count)}`;

                    reactionSummary.appendChild(
                        badge
                    );
                }
            );

        if (
            reactionSummary.children.length
            === 0
        ) {
            const emptyText =
                document.createElement(
                    'span'
                );

            emptyText.className =
                'text-xs font-semibold text-slate-500';

            emptyText.textContent =
                'No reactions yet';

            reactionSummary.appendChild(
                emptyText
            );
        }
    }

    reactionChoiceButtons.forEach(
        (button) => {
            const reaction =
                button.dataset
                    .photoReactionChoice;

            const selected =
                photo.selectedReaction
                === reaction;

            button.setAttribute(
                'aria-pressed',
                selected
                    ? 'true'
                    : 'false'
            );

            button.classList.toggle(
                'ring-2',
                selected
            );

            button.classList.toggle(
                'ring-cyan-300',
                selected
            );

            button.classList.toggle(
                'border-cyan-300/70',
                selected
            );

            button.classList.toggle(
                'bg-cyan-400/15',
                selected
            );

            const choiceCount =
                button.querySelector(
                    `[data-photo-reaction-choice-count="${reaction}"]`
                );

            if (choiceCount) {
                choiceCount.textContent =
                    numberFormatter.format(
                        parseCount(
                            photo.reactionCounts[
                                reaction
                            ]
                        )
                    );
            }
        }
    );

    if (selectedReactionMessage) {
        const selectedDefinition =
            photo.selectedReaction
                ? reactionDefinitions[
                    photo.selectedReaction
                ]
                : null;

        selectedReactionMessage.textContent =
            selectedDefinition
                ? `Your reaction: ${selectedDefinition.emoji} ${selectedDefinition.label}`
                : '';

        selectedReactionMessage.classList.toggle(
            'hidden',
            !selectedDefinition
        );
    }

    if (photo.authenticated) {
        reactionForm?.classList.remove(
            'hidden'
        );

        loginLink?.classList.add(
            'hidden'
        );

        loginLink?.classList.remove(
            'flex'
        );

        if (reactionForm) {
            reactionForm.action =
                photo.reactionUrl;
        }

        return;
    }

    reactionForm?.classList.add(
        'hidden'
    );

    if (loginLink) {
        loginLink.href =
            photo.loginUrl;

        loginLink.classList.remove(
            'hidden'
        );

        loginLink.classList.add(
            'flex'
        );
    }
};
const updateGalleryReactionSummary = (
    photoId,
    reactionCounts,
    reactionCount
) => {
    const popularReactions = Object.entries(
        reactionCounts
    )
        .filter(
            ([, count]) =>
                parseCount(count) > 0
        )
        .sort(
            ([, firstCount], [, secondCount]) =>
                parseCount(secondCount)
                - parseCount(firstCount)
        )
        .slice(0, 3);

    document
        .querySelectorAll(
            `[data-photo-reaction-emojis-for="${photoId}"]`
        )
        .forEach((container) => {
            container.innerHTML = '';

            if (
                popularReactions.length
                === 0
            ) {
                const emptyHeart =
                    document.createElement(
                        'span'
                    );

                emptyHeart.className =
                    'text-slate-400';

                emptyHeart.textContent =
    '♡';

                container.appendChild(
                    emptyHeart
                );

                return;
            }

            popularReactions.forEach(
                ([reaction]) => {
                    const definition =
                        reactionDefinitions[
                            reaction
                        ];

                    if (!definition) {
                        return;
                    }

                    const emoji =
                        document.createElement(
                            'span'
                        );

                    emoji.textContent =
                        definition.emoji;

                    container.appendChild(
                        emoji
                    );
                }
            );
        });

    document
        .querySelectorAll(
            `[data-photo-reaction-count-for="${photoId}"]`
        )
        .forEach((element) => {
            element.textContent =
                numberFormatter.format(
                    reactionCount
                );
        });

    document
        .querySelectorAll(
            `[data-photo-reaction-badge-for="${photoId}"]`
        )
        .forEach((badge) => {
            badge.setAttribute(
                'aria-label',
                formatReactionText(
                    reactionCount
                )
            );
        });
};

    const updatePhotoReactionState = (
    photoId,
    data
) => {
    const normalizedCounts = {
        like: parseCount(
            data.reaction_counts?.like
        ),

        fire: parseCount(
            data.reaction_counts?.fire
        ),

        funny: parseCount(
            data.reaction_counts?.funny
        ),

        love: parseCount(
            data.reaction_counts?.love
        ),

        rock_on: parseCount(
            data.reaction_counts?.rock_on
        ),
    };

    const summary = Object.entries(
        normalizedCounts
    )
        .filter(
            ([, count]) => count > 0
        )
        .map(
            ([reaction, count]) => ({
                reaction,

                label:
                    reactionDefinitions[
                        reaction
                    ]?.label
                    ?? reaction,

                emoji:
                    reactionDefinitions[
                        reaction
                    ]?.emoji
                    ?? '',

                count,
            })
        );

    triggers.forEach((trigger) => {
        if (
            trigger.dataset.photoId
            !== String(photoId)
        ) {
            return;
        }

        trigger.dataset
            .photoSelectedReaction =
            data.selected_reaction
            ?? '';

        trigger.dataset
            .photoHasReaction =
            data.has_reaction
                ? 'true'
                : 'false';

        trigger.dataset
            .photoReactionCount =
            String(
                parseCount(
                    data.reaction_count
                )
            );

        trigger.dataset
            .photoReactionCounts =
            JSON.stringify(
                normalizedCounts
            );

        trigger.dataset
            .photoReactionSummary =
            JSON.stringify(summary);

        /*
         * Temporary compatibility with the
         * existing gallery Like badges.
         */
        trigger.dataset.photoLiked =
            data.liked
                ? 'true'
                : 'false';

        trigger.dataset.photoLikeCount =
            String(
                parseCount(
                    data.like_count
                )
            );
    });

    document
        .querySelectorAll(
            `[data-photo-like-count-for="${photoId}"]`
        )
        .forEach((element) => {
            element.textContent =
                numberFormatter.format(
                    parseCount(
                        data.like_count
                    )
                );

            element
                .closest('[aria-label]')
                ?.setAttribute(
                    'aria-label',
                    formatLikeText(
                        parseCount(
                            data.like_count
                        )
                    )
                );
        });

updateGalleryReactionSummary(
    photoId,
    normalizedCounts,
    parseCount(
        data.reaction_count
    )
);
    const activePhoto = getPhotoData(
        triggers[currentIndex]
    );

    if (
        activePhoto.id
        === String(photoId)
    ) {
        renderReactionControls(
            activePhoto
        );
    }
};

    /*
    |--------------------------------------------------------------------------
    | Comment count synchronization
    |--------------------------------------------------------------------------
    */

    const updatePhotoCommentCount = (
        photoId,
        commentCount
    ) => {
        triggers.forEach((trigger) => {
            if (
                trigger.dataset.photoId
                !== String(photoId)
            ) {
                return;
            }

            trigger.dataset
                .photoCommentCount =
                String(commentCount);
        });

        document
            .querySelectorAll(
                `[data-photo-comment-count-for="${photoId}"]`
            )
            .forEach((element) => {
                element.textContent =
                    numberFormatter.format(
                        commentCount
                    );

                element
                    .closest('[aria-label]')
                    ?.setAttribute(
                        'aria-label',
                        formatCommentText(
                            commentCount
                        )
                    );
            });

        const activePhoto = getPhotoData(
            triggers[currentIndex]
        );

        if (
            activePhoto.id
            === String(photoId)
            && modalCommentCount
        ) {
            modalCommentCount.textContent =
                formatCommentText(
                    commentCount
                );
        }
    };

    /*
    |--------------------------------------------------------------------------
    | Comment rendering
    |--------------------------------------------------------------------------
    */
const renderCommentBody = (
    element,
    comment
) => {
    element.innerHTML = '';

    const text =
        comment.body ?? '';

    const mentions =
        Array.isArray(
            comment.mentions
        )
            ? comment.mentions
            : [];

    const mentionsByUsername =
        new Map(
            mentions
                .filter(
                    (mention) =>
                        mention?.username
                        && mention
                            ?.profile_url
                )
                .map(
                    (mention) => [
                        String(
                            mention.username
                        ).toLowerCase(),

                        mention,
                    ]
                )
        );

    if (
        text === ''
        || mentionsByUsername.size === 0
    ) {
        element.textContent = text;

        return;
    }

    const mentionPattern =
        /(?<![A-Za-z0-9_])@([A-Za-z0-9_]{3,30})/g;

    let previousIndex = 0;

    let match;

    while (
        (
            match =
                mentionPattern.exec(text)
        ) !== null
    ) {
        const matchIndex =
            match.index;

        if (
            matchIndex
            > previousIndex
        ) {
            element.appendChild(
                document.createTextNode(
                    text.slice(
                        previousIndex,
                        matchIndex
                    )
                )
            );
        }

        const username =
            match[1];

        const mention =
            mentionsByUsername.get(
                username.toLowerCase()
            );

        if (mention) {
            const link =
                document.createElement(
                    'a'
                );

            link.href =
                mention.profile_url;

            link.textContent =
                match[0];

            link.className =
                'font-bold text-cyan-300 transition hover:text-cyan-200 hover:underline';

            link.addEventListener(
                'click',
                (event) => {
                    event.stopPropagation();
                }
            );

            element.appendChild(link);
        } else {
            element.appendChild(
                document.createTextNode(
                    match[0]
                )
            );
        }

        previousIndex =
            mentionPattern.lastIndex;
    }

    if (
        previousIndex
        < text.length
    ) {
        element.appendChild(
            document.createTextNode(
                text.slice(
                    previousIndex
                )
            )
        );
    }
};
    const createCommentElement = (
    comment
) => {
    const article =
        document.createElement(
            'article'
        );

    article.className =
        'rounded-xl border border-zinc-200 bg-zinc-50 p-4 dark:border-white/10 dark:bg-slate-950/40';

    article.dataset.photoCommentId =
        String(comment.id);

	article.id =
    `photo-comment-${comment.id}`;

    article.dataset.photoCommentBody =
        comment.body;

    article.dataset.photoCommentUpdateUrl =
        comment.update_url ?? '';

    const header =
        document.createElement('div');

    header.className =
        'flex items-start justify-between gap-3';

    const authorArea =
        document.createElement('div');

    authorArea.className =
        'flex min-w-0 items-center gap-3';

    const avatar =
    comment.author?.profile_photo_url
        ? document.createElement('img')
        : document.createElement('div');

if (
    avatar instanceof HTMLImageElement
    && comment.author?.profile_photo_url
) {
    avatar.src =
        comment.author.profile_photo_url;

    avatar.alt =
        `${comment.author?.name || 'Member'} profile photo`;

    avatar.loading = 'lazy';

    avatar.className =
        'h-9 w-9 shrink-0 rounded-full object-cover ring-1 ring-white/10';
} else {
    avatar.className =
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-cyan-50 text-xs font-black text-cyan-700 ring-1 ring-cyan-200 dark:bg-cyan-400/15 dark:text-cyan-200 dark:ring-white/10';

    avatar.textContent =
        comment.author?.initials
        || '?';
}

    const authorText =
        document.createElement('div');

    authorText.className =
        'min-w-0';

    const authorName =
        comment.author?.profile_url
            ? document.createElement('a')
            : document.createElement('span');

    authorName.className =
        'block truncate text-sm font-black text-zinc-950 dark:text-white';

    authorName.textContent =
        comment.author?.name
        || 'FestFriends member';

    if (
        comment.author?.profile_url
        && authorName instanceof
            HTMLAnchorElement
    ) {
        authorName.href =
            comment.author.profile_url;
    }

    authorText.appendChild(
        authorName
    );

    const metadata =
        document.createElement('p');

    metadata.className =
        'mt-0.5 text-xs text-slate-500';

    metadata.dataset.photoCommentMetadata =
        'true';

    const metadataParts = [
        comment.created_at_human,

        comment.edited
            ? 'Edited'
            : '',

        comment.author?.is_organizer
            ? 'Festival Organizer'
            : '',
    ].filter(Boolean);

    metadata.textContent =
        metadataParts.join(' · ');

    metadata.dataset.createdAtHuman =
        comment.created_at_human ?? '';

    metadata.dataset.isOrganizer =
        comment.author?.is_organizer
            ? 'true'
            : 'false';

    authorText.appendChild(metadata);

    authorArea.appendChild(avatar);

    authorArea.appendChild(
        authorText
    );

    header.appendChild(authorArea);

    if (comment.can_modify) {
        const actions =
            document.createElement('div');

        actions.className =
            'flex shrink-0 items-center gap-1';

        const editButton =
            document.createElement(
                'button'
            );

        editButton.type = 'button';

        editButton.className =
            'rounded-lg px-2 py-1 text-xs font-bold text-cyan-700 transition hover:bg-cyan-50 hover:text-cyan-800 disabled:cursor-wait disabled:opacity-60 dark:text-cyan-300 dark:hover:bg-cyan-400/10 dark:hover:text-cyan-200';

        editButton.textContent =
            'Edit';

        editButton.dataset
            .photoCommentEdit =
            'true';

        const deleteButton =
            document.createElement(
                'button'
            );

        deleteButton.type = 'button';

        deleteButton.className =
            'rounded-lg px-2 py-1 text-xs font-bold text-rose-700 transition hover:bg-rose-50 hover:text-rose-800 disabled:cursor-wait disabled:opacity-60 dark:text-rose-300 dark:hover:bg-rose-400/10 dark:hover:text-rose-200';

        deleteButton.textContent =
            'Delete';

        deleteButton.dataset
            .photoCommentDelete =
            comment.delete_url;

        deleteButton.dataset
            .photoCommentBody =
            comment.body;

        actions.appendChild(
            editButton
        );

        actions.appendChild(
            deleteButton
        );

        header.appendChild(actions);
    }

    const body =
        document.createElement('p');

    body.className =
        'mt-3 whitespace-pre-line break-words text-sm leading-6 text-zinc-700 dark:text-slate-300';

    renderCommentBody(
    body,
    comment
);

    body.dataset.photoCommentBodyDisplay =
        'true';

    article.appendChild(header);

    article.appendChild(body);

    return article;
};

const updateCommentMetadata = (
    article,
    edited = true
) => {
    const metadata =
        article.querySelector(
            '[data-photo-comment-metadata]'
        );

    if (!metadata) {
        return;
    }

    const parts = [
        metadata.dataset
            .createdAtHuman
        ?? '',

        edited
            ? 'Edited'
            : '',

        metadata.dataset
            .isOrganizer
            === 'true'
            ? 'Festival Organizer'
            : '',
    ].filter(Boolean);

    metadata.textContent =
        parts.join(' · ');
};

const cancelCommentEdit = (
    article
) => {
    const editor =
        article.querySelector(
            '[data-photo-comment-editor]'
        );

    const bodyDisplay =
        article.querySelector(
            '[data-photo-comment-body-display]'
        );

    editor?.remove();

    bodyDisplay?.classList.remove(
        'hidden'
    );

    article
        .querySelectorAll(
            '[data-photo-comment-edit], [data-photo-comment-delete]'
        )
        .forEach((button) => {
            button.disabled = false;
        });

    if (
        activeCommentEditArticle
        === article
    ) {
        activeCommentEditArticle =
            null;
    }
};

const beginCommentEdit = (
    article
) => {

	slideshow.pause();

    if (
        activeCommentEditArticle
        && activeCommentEditArticle
            !== article
    ) {
        cancelCommentEdit(
            activeCommentEditArticle
        );
    }

    const bodyDisplay =
        article.querySelector(
            '[data-photo-comment-body-display]'
        );

    if (!bodyDisplay) {
        return;
    }

    activeCommentEditArticle =
        article;

    bodyDisplay.classList.add(
        'hidden'
    );

    article
        .querySelectorAll(
            '[data-photo-comment-edit], [data-photo-comment-delete]'
        )
        .forEach((button) => {
            button.disabled = true;
        });

    const editor =
        document.createElement('div');

    editor.className =
        'mt-3';

    editor.dataset.photoCommentEditor =
        'true';

    const textarea =
        document.createElement(
            'textarea'
        );

    textarea.rows = 4;
    textarea.maxLength = 2000;

    textarea.className =
        'block w-full resize-y rounded-xl border border-zinc-300 bg-white px-4 py-3 text-sm leading-6 text-zinc-900 placeholder:text-zinc-400 focus:border-cyan-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/20 dark:border-white/10 dark:bg-slate-950/70 dark:text-white dark:placeholder:text-slate-500 dark:focus:border-cyan-400/50 dark:focus:ring-cyan-300/30';

    textarea.value =
        article.dataset
            .photoCommentBody
        ?? '';

    textarea.dataset
        .photoCommentEditBody =
        'true';

    const error =
        document.createElement('p');

    error.className =
        'mt-2 hidden text-sm font-semibold text-rose-300';

    error.dataset
        .photoCommentEditError =
        'true';

    error.setAttribute(
        'role',
        'alert'
    );

    const controls =
        document.createElement('div');

    controls.className =
        'mt-3 flex flex-wrap justify-end gap-2';

    const cancelButton =
        document.createElement(
            'button'
        );

    cancelButton.type = 'button';

    cancelButton.className =
        'rounded-xl border border-zinc-300 bg-white px-4 py-2 text-xs font-bold text-zinc-700 transition hover:bg-zinc-100 dark:border-white/10 dark:bg-white/5 dark:text-slate-200 dark:hover:bg-white/10';

    cancelButton.textContent =
        'Cancel';

    cancelButton.dataset
        .photoCommentEditCancel =
        'true';

    const saveButton =
        document.createElement(
            'button'
        );

    saveButton.type = 'button';

    saveButton.className =
        'rounded-xl bg-cyan-300 px-4 py-2 text-xs font-black text-slate-950 transition hover:bg-cyan-200 disabled:cursor-wait disabled:opacity-60';

    saveButton.textContent =
        'Save Changes';

    saveButton.dataset
        .photoCommentEditSave =
        'true';

    controls.appendChild(
        cancelButton
    );

    controls.appendChild(
        saveButton
    );

    editor.appendChild(textarea);

    editor.appendChild(error);

    editor.appendChild(controls);

    article.appendChild(editor);

    textarea.focus();

    textarea.setSelectionRange(
        textarea.value.length,
        textarea.value.length
    );
};

const showCommentEditError = (
    article,
    message
) => {
    const error =
        article.querySelector(
            '[data-photo-comment-edit-error]'
        );

    if (!error) {
        return;
    }

    error.textContent = message;

    error.classList.remove(
        'hidden'
    );
};

const clearCommentEditError = (
    article
) => {
    const error =
        article.querySelector(
            '[data-photo-comment-edit-error]'
        );

    if (!error) {
        return;
    }

    error.textContent = '';

    error.classList.add(
        'hidden'
    );
};

const saveCommentEdit = async (
    article
) => {
    const textarea =
        article.querySelector(
            '[data-photo-comment-edit-body]'
        );

    const saveButton =
        article.querySelector(
            '[data-photo-comment-edit-save]'
        );

    const updateUrl =
        article.dataset
            .photoCommentUpdateUrl;

    const body =
        textarea?.value.trim()
        ?? '';

    if (!body) {
        showCommentEditError(
            article,
            'Please enter a comment.'
        );

        textarea?.focus();

        return;
    }

    if (!updateUrl) {
        showCommentEditError(
            article,
            'This comment cannot be updated right now.'
        );

        return;
    }

    if (!csrfToken) {
        showCommentEditError(
            article,
            'Your security token is missing. Refresh the page and try again.'
        );

        return;
    }

    clearCommentEditError(
        article
    );

    if (saveButton) {
        saveButton.disabled = true;

        saveButton.textContent =
            'Saving...';
    }

    try {
        const response = await fetch(
            updateUrl,
            {
                method: 'PATCH',

                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'Content-Type':
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',

                    'X-CSRF-TOKEN':
                        csrfToken,
                },

                body: JSON.stringify({
                    body,
                }),
            }
        );

        if (response.status === 401) {
            const activePhoto =
                getPhotoData(
                    triggers[
                        currentIndex
                    ]
                );

            window.location.href =
                activePhoto.loginUrl;

            return;
        }

        if (response.status === 419) {
            throw new Error(
                'Your session expired. Refresh the page and try again.'
            );
        }

        const data =
            await response.json();

        if (!response.ok) {
            const validationMessage =
                data.errors?.body?.[0];

            throw new Error(
                validationMessage
                || data.message
                || 'The comment could not be updated.'
            );
        }

        const updatedComment =
            data.comment;

const activePhoto =
    getPhotoData(
        triggers[currentIndex]
    );

updateCommentInCache(
    activePhoto.id,
    updatedComment
);

        const bodyDisplay =
            article.querySelector(
                '[data-photo-comment-body-display]'
            );

        if (bodyDisplay) {
            renderCommentBody(
    bodyDisplay,
    updatedComment
);
        }

        article.dataset
            .photoCommentBody =
            updatedComment.body;

        const deleteButton =
            article.querySelector(
                '[data-photo-comment-delete]'
            );

        if (deleteButton) {
            deleteButton.dataset
                .photoCommentBody =
                updatedComment.body;
        }

        updateCommentMetadata(
            article,
            Boolean(
                updatedComment.edited
            )
        );

        cancelCommentEdit(
            article
        );
    } catch (error) {
        showCommentEditError(
            article,
            error.message
            || 'The comment could not be updated.'
        );

        if (saveButton) {
            saveButton.disabled =
                false;

            saveButton.textContent =
                'Save Changes';
        }
    }
};

    const renderComments = (
        comments,
        append = false
    ) => {
        if (!commentsList) {
            return;
        }

        if (!append) {
            commentsList.innerHTML = '';
        }

        comments.forEach((comment) => {
            commentsList.appendChild(
                createCommentElement(
                    comment
                )
            );
        });

        const hasComments =
            commentsList.children.length
            > 0;

        commentsEmpty?.classList.toggle(
            'hidden',
            hasComments
        );
    };

const renderCachedComments = (
    photoId,
    cachedData
) => {
    renderComments(
        cachedData.comments ?? []
    );

    commentsNextPageUrl =
        cachedData.nextPageUrl
        || null;

    commentsMoreButton
        ?.classList
        .toggle(
            'hidden',
            !cachedData.hasMorePages
        );

    updatePhotoCommentCount(
        photoId,
        parseCount(
            cachedData.commentCount
        )
    );

    loadedCommentsPhotoId =
        String(photoId);

    clearCommentsError(
    commentsError
);
};

    /*
    |--------------------------------------------------------------------------
    | Comment loading
    |--------------------------------------------------------------------------
    */

    const loadComments = async (
    url,
    append = false,
    photoId = null
) => {
    if (
        !commentsList
        || !commentsLoading
        || !commentsMoreButton
    ) {
        return;
    }

    const requestedPhotoId =
        String(
            photoId
            ?? getPhotoData(
                triggers[currentIndex]
            ).id
        );

    if (!url) {
        showCommentsError(
			commentsError,
            'Comments are unavailable for this photo.'
        );

        return;
    }

    const requestNumber =
        ++commentsRequestNumber;

    clearCommentsError(
    commentsError
);

    if (!append) {
        commentsList.innerHTML = '';

        commentsEmpty?.classList.add(
            'hidden'
        );

        commentsLoading.classList.remove(
            'hidden'
        );

        commentsLoading.classList.add(
            'flex'
        );
    } else {
        commentsMoreButton.disabled =
            true;

        commentsMoreButton.textContent =
            'Loading...';
    }

    try {
        const response = await fetch(
            url,
            {
                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',
                },
            }
        );

        const data =
            await response.json();

        if (!response.ok) {
            throw new Error(
                data.message
                || 'Comments could not be loaded.'
            );
        }

        if (
            requestNumber
            !== commentsRequestNumber
        ) {
            return;
        }

        const activePhoto =
            getPhotoData(
                triggers[currentIndex]
            );

        if (
            String(activePhoto.id)
            !== requestedPhotoId
        ) {
            return;
        }

        const receivedComments =
            Array.isArray(data.comments)
                ? data.comments
                : [];

        const existingCache =
            getCachedComments(
                requestedPhotoId
            );

        const cachedComments =
            append && existingCache
                ? [
                    ...existingCache.comments,
                    ...receivedComments,
                ]
                : receivedComments;

        renderComments(
            receivedComments,
            append
        );

        commentsNextPageUrl =
            data.next_page_url
            || null;

        const hasMorePages =
            Boolean(
                data.has_more_pages
            );

        commentsMoreButton
            .classList
            .toggle(
                'hidden',
                !hasMorePages
            );

        const commentCount =
            parseCount(
                data.comment_count
            );

        setCachedComments(
            requestedPhotoId,
            {
                comments:
                    cachedComments,

                nextPageUrl:
                    commentsNextPageUrl,

                hasMorePages,

                commentCount,
            }
        );

        updatePhotoCommentCount(
            requestedPhotoId,
            commentCount
        );

        loadedCommentsPhotoId =
            requestedPhotoId;
    } catch (error) {
        if (
            requestNumber
            !== commentsRequestNumber
        ) {
            return;
        }

        showCommentsError(
    commentsError,
    error.message
    || 'Comments could not be loaded.'
);
    } finally {
        if (
            requestNumber
            === commentsRequestNumber
        ) {
            commentsLoading
                .classList
                .add('hidden');

            commentsLoading
                .classList
                .remove('flex');

            commentsMoreButton.disabled =
                false;

            commentsMoreButton
                .textContent =
                'Load More Comments';
        }
    }
};

const loadCurrentPhotoComments = (
    forceReload = false
) => {
    const activePhoto =
        getPhotoData(
            triggers[currentIndex]
        );

    const photoId =
        String(activePhoto.id);

    if (
        !forceReload
        && loadedCommentsPhotoId
            === photoId
    ) {
        return;
    }

    const cachedData =
        getCachedComments(
            photoId
        );

    if (!forceReload && cachedData) {
        renderCachedComments(
            photoId,
            cachedData
        );

        return;
    }

    commentsNextPageUrl = null;

    loadComments(
        activePhoto.commentsUrl,
        false,
        photoId
    );
};

/*
|--------------------------------------------------------------------------
| Photo tag rendering
|--------------------------------------------------------------------------
*/

const clearTagsError = () => {
    if (!tagsError) {
        return;
    }

    tagsError.textContent = '';

    tagsError.classList.add(
        'hidden'
    );
};

const showTagsError = (
    message
) => {
    if (!tagsError) {
        return;
    }

    tagsError.textContent =
        message;

    tagsError.classList.remove(
        'hidden'
    );
};

const formatTagCount = (
    count
) => {
    const normalizedCount =
        parseCount(count);

    return `${numberFormatter.format(
        normalizedCount
    )} ${
        normalizedCount === 1
            ? 'Tagged Friend'
            : 'Tagged Friends'
    }`;
};

const createTaggedFriendElement = (
    tag
) => {
    const article =
        document.createElement(
            'article'
        );

    article.className =
        'flex items-center justify-between gap-3 rounded-xl border border-zinc-200 bg-white p-3 dark:border-white/10 dark:bg-slate-950/40';

    article.dataset.photoTagId =
        String(tag.id);

    const memberArea =
        document.createElement('div');

    memberArea.className =
        'flex min-w-0 items-center gap-3';

    const member =
        tag.member ?? {};

    const avatar =
        member.profile_photo_url
            ? document.createElement(
                'img'
            )
            : document.createElement(
                'div'
            );

    if (
        avatar instanceof
            HTMLImageElement
        && member.profile_photo_url
    ) {
        avatar.src =
            member.profile_photo_url;

        avatar.alt =
            `${member.name || 'Member'} profile photo`;

        avatar.loading = 'lazy';

        avatar.className =
            'h-10 w-10 shrink-0 rounded-full object-cover ring-1 ring-white/10';
    } else {
        avatar.className =
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cyan-50 text-xs font-black text-cyan-700 ring-1 ring-cyan-200 dark:bg-cyan-400/15 dark:text-cyan-200 dark:ring-white/10';

        avatar.textContent =
            member.initials || '?';
    }

    const memberText =
        document.createElement('div');

    memberText.className =
        'min-w-0';

    const memberName =
        member.profile_url
            ? document.createElement('a')
            : document.createElement(
                'span'
            );

    memberName.className =
        'block truncate text-sm font-black text-zinc-950 dark:text-white';

    memberName.textContent =
        member.name
        || 'FestFriends member';

    if (
        memberName instanceof
            HTMLAnchorElement
        && member.profile_url
    ) {
        memberName.href =
            member.profile_url;

        memberName.classList.add(
            'transition',
            'hover:text-cyan-200'
        );
    }

    memberText.appendChild(
        memberName
    );

    if (member.username) {
        const username =
            document.createElement('p');

        username.className =
            'mt-0.5 truncate text-xs text-slate-500';

        username.textContent =
            `@${member.username}`;

        memberText.appendChild(
            username
        );
    }

    memberArea.appendChild(
        avatar
    );

    memberArea.appendChild(
        memberText
    );

    article.appendChild(
    memberArea
);

if (
    tag.can_remove
    && tag.delete_url
) {
    const removeButton =
        document.createElement(
            'button'
        );

    removeButton.type = 'button';

    removeButton.className =
        'shrink-0 rounded-lg px-3 py-2 text-xs font-bold text-rose-700 transition hover:bg-rose-50 hover:text-rose-800 disabled:cursor-wait disabled:opacity-60 dark:text-rose-300 dark:hover:bg-rose-400/10 dark:hover:text-rose-200';

    removeButton.textContent =
        'Remove';

    removeButton.dataset
        .photoTagRemove =
        tag.delete_url;

    removeButton.dataset
        .photoTagMemberName =
        member.name
        || 'this member';

    article.appendChild(
        removeButton
    );
}

return article;
};

const closeOpenTagLabels = (
    exceptMarker = null
) => {
    tagOverlay
        ?.querySelectorAll(
            '[data-photo-tag-label]'
        )
        .forEach((label) => {
            if (
                exceptMarker
                && label.closest(
                    '[data-photo-tag-marker-id]'
                ) === exceptMarker
            ) {
                return;
            }

            label.classList.add(
                'hidden'
            );
        });
};

const togglePhotoTagLabel = (
    marker
) => {
    const label =
        marker.querySelector(
            '[data-photo-tag-label]'
        );

    if (!label) {
        return;
    }

    const willOpen =
        label.classList.contains(
            'hidden'
        );

    closeOpenTagLabels(
        willOpen
            ? marker
            : null
    );

    label.classList.toggle(
        'hidden',
        !willOpen
    );
};

const renderPhotoTagVisibility = () => {
    if (!tagOverlay) {
        return;
    }

    tagOverlay.classList.toggle(
        'hidden',
        !photoTagsVisible
    );

    if (tagToggleButton) {
        tagToggleButton.textContent =
            photoTagsVisible
                ? 'Hide Tags'
                : 'Show Tags';

        tagToggleButton.setAttribute(
            'aria-pressed',
            photoTagsVisible
                ? 'true'
                : 'false'
        );
    }

    if (!photoTagsVisible) {
        closeOpenTagLabels();
    }
};

const renderPhotoTags = (
    tags
) => {
    if (!tagsList) {
        return;
    }
currentPhotoTags =
    Array.isArray(tags)
        ? tags
        : [];

renderPhotoTagMarkers(
    currentPhotoTags
);

    tagsList.innerHTML = '';

    currentPhotoTags.forEach((tag) => {
        tagsList.appendChild(
            createTaggedFriendElement(
                tag
            )
        );
    });

    const hasTags =
    currentPhotoTags.length > 0;

    tagsEmpty?.classList.toggle(
        'hidden',
        hasTags
    );
};

const resetPhotoTags = () => {
    tagsRequestNumber++;

tagMembersRequestNumber++;

clearTagPlacement();

currentPhotoTags = [];

clearPhotoTagMarkers();

photoTagsVisible = true;

closeOpenTagLabels();

tagToggleButton?.classList.add(
    'hidden'
);

if (
    tagSearchTimeoutId !== null
) {
    window.clearTimeout(
        tagSearchTimeoutId
    );

    tagSearchTimeoutId = null;
}

    loadedTagsPhotoId = null;

    currentTagStoreUrl = null;

    currentEligibleMembersUrl = null;

    if (tagsList) {
        tagsList.innerHTML = '';
    }

    if (tagCount) {
        tagCount.textContent =
            formatTagCount(0);
    }

    tagsEmpty?.classList.add(
        'hidden'
    );

    tagsLoading?.classList.add(
        'hidden'
    );

    tagsLoading?.classList.remove(
        'flex'
    );

    tagOpenButton?.classList.add(
        'hidden'
    );

    tagPicker?.classList.add(
        'hidden'
    );

    if (tagSearch) {
        tagSearch.value = '';
    }

    if (tagMembersList) {
        tagMembersList.innerHTML = '';
    }

    tagMembersLoading?.classList.add(
        'hidden'
    );

    tagMembersLoading?.classList.remove(
        'flex'
    );

    tagMembersError?.classList.add(
        'hidden'
    );

    tagMembersEmpty?.classList.add(
        'hidden'
    );

    clearTagsError();
};

const loadPhotoTags = async (
    photo
) => {
    if (
        !tagsList
        || !tagsLoading
    ) {
        return;
    }

    const photoId =
        String(photo.id);

    if (!photo.tagsUrl) {
        showTagsError(
            'Tagged friends are unavailable for this photo.'
        );

        return;
    }

    const requestNumber =
        ++tagsRequestNumber;

    clearTagsError();

    tagsLoading.classList.remove(
        'hidden'
    );

    tagsLoading.classList.add(
        'flex'
    );

    tagsEmpty?.classList.add(
        'hidden'
    );

    try {
        const response = await fetch(
            photo.tagsUrl,
            {
                method: 'GET',

                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',
                },
            }
        );

        const data =
            await response.json();

        if (!response.ok) {
            throw new Error(
                data.message
                || 'Tagged friends could not be loaded.'
            );
        }

        if (
            requestNumber
            !== tagsRequestNumber
        ) {
            return;
        }

        const activePhoto =
            getPhotoData(
                triggers[currentIndex]
            );

        if (
            String(activePhoto.id)
            !== photoId
        ) {
            return;
        }

        const tags =
            Array.isArray(data.tags)
                ? data.tags
                : [];

        renderPhotoTags(tags);

        if (tagCount) {
            tagCount.textContent =
                formatTagCount(
                    data.tag_count
                );
        }

        const canManageTags =
            Boolean(
                data.can_manage_tags
            );

        tagOpenButton?.classList.toggle(
            'hidden',
            !canManageTags
        );

        currentTagStoreUrl =
            canManageTags
                ? data.store_url || null
                : null;

        currentEligibleMembersUrl =
            canManageTags
                ? data.eligible_members_url
                    || null
                : null;

        loadedTagsPhotoId =
            photoId;
    } catch (error) {
        if (
            requestNumber
            !== tagsRequestNumber
        ) {
            return;
        }

        showTagsError(
            error.message
            || 'Tagged friends could not be loaded.'
        );
    } finally {
        if (
            requestNumber
            === tagsRequestNumber
        ) {
            tagsLoading.classList.add(
                'hidden'
            );

            tagsLoading.classList.remove(
                'flex'
            );
        }
    }
};

/*
|--------------------------------------------------------------------------
| Tag-friend picker
|--------------------------------------------------------------------------
*/

const clearTagMembersError = () => {
    if (!tagMembersError) {
        return;
    }

    tagMembersError.textContent = '';

    tagMembersError.classList.add(
        'hidden'
    );
};

const showTagMembersError = (
    message
) => {
    if (!tagMembersError) {
        return;
    }

    tagMembersError.textContent =
        message;

    tagMembersError.classList.remove(
        'hidden'
    );
};

const closeTagPicker = () => {
    tagMembersRequestNumber++;

    if (
        tagSearchTimeoutId !== null
    ) {
        window.clearTimeout(
            tagSearchTimeoutId
        );

        tagSearchTimeoutId = null;
    }

    tagPicker?.classList.add(
        'hidden'
    );

    if (tagSearch) {
        tagSearch.value = '';
    }

    if (tagMembersList) {
        tagMembersList.innerHTML = '';
    }

    tagMembersLoading?.classList.add(
        'hidden'
    );

    tagMembersLoading?.classList.remove(
        'flex'
    );

    tagMembersEmpty?.classList.add(
        'hidden'
    );

    clearTagMembersError();
};

const createTaggableMemberElement = (
    member
) => {
    const article =
        document.createElement(
            'article'
        );

    article.className =
        'flex items-center justify-between gap-3 rounded-xl border border-zinc-200 bg-white p-3 dark:border-white/10 dark:bg-white/5';

    article.dataset
        .photoTaggableMemberId =
        String(member.id);

    const memberArea =
        document.createElement('div');

    memberArea.className =
        'flex min-w-0 items-center gap-3';

    const avatar =
        member.profile_photo_url
            ? document.createElement(
                'img'
            )
            : document.createElement(
                'div'
            );

    if (
        avatar instanceof
            HTMLImageElement
        && member.profile_photo_url
    ) {
        avatar.src =
            member.profile_photo_url;

        avatar.alt =
            `${member.name || 'Member'} profile photo`;

        avatar.loading = 'lazy';

        avatar.className =
            'h-10 w-10 shrink-0 rounded-full object-cover ring-1 ring-white/10';
    } else {
        avatar.className =
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-cyan-50 text-xs font-black text-cyan-700 ring-1 ring-cyan-200 dark:bg-cyan-400/15 dark:text-cyan-200 dark:ring-white/10';

        avatar.textContent =
            member.initials || '?';
    }

    const memberText =
        document.createElement('div');

    memberText.className =
        'min-w-0';

    const memberName =
        document.createElement('p');

    memberName.className =
        'truncate text-sm font-black text-zinc-950 dark:text-white';

    memberName.textContent =
        member.name
        || 'FestFriends member';

    memberText.appendChild(
        memberName
    );

    if (member.username) {
        const username =
            document.createElement('p');

        username.className =
            'mt-0.5 truncate text-xs text-slate-500';

        username.textContent =
            `@${member.username}`;

        memberText.appendChild(
            username
        );
    }

    memberArea.appendChild(
        avatar
    );

    memberArea.appendChild(
        memberText
    );

    const tagButton =
        document.createElement(
            'button'
        );

    tagButton.type = 'button';

    tagButton.dataset
        .photoTagMember =
        String(member.id);

    tagButton.className =
        'shrink-0 rounded-lg px-3 py-2 text-xs font-black transition disabled:cursor-not-allowed disabled:opacity-60';

    if (member.is_already_tagged) {
        tagButton.disabled = true;

        tagButton.textContent =
            'Tagged';

        tagButton.classList.add(
            'border',
            'border-white/10',
            'bg-white/5',
            'text-slate-500'
        );
    } else {
        tagButton.textContent =
            'Tag';

        tagButton.classList.add(
            'bg-cyan-300',
            'text-slate-950',
            'hover:bg-cyan-200'
        );
    }

    article.appendChild(
        memberArea
    );

    article.appendChild(
        tagButton
    );

    return article;
};

const renderTaggableMembers = (
    members
) => {
    if (!tagMembersList) {
        return;
    }

    tagMembersList.innerHTML = '';

    members.forEach((member) => {
        tagMembersList.appendChild(
            createTaggableMemberElement(
                member
            )
        );
    });

    tagMembersEmpty?.classList.toggle(
        'hidden',
        members.length > 0
    );
};

const loadTaggableMembers = async (
    search = ''
) => {
    if (
        !currentEligibleMembersUrl
        || !tagMembersList
        || !tagMembersLoading
    ) {
        showTagMembersError(
            'Eligible friends cannot be loaded right now.'
        );

        return;
    }

    const requestNumber =
        ++tagMembersRequestNumber;

    clearTagMembersError();

    tagMembersList.innerHTML = '';

    tagMembersEmpty?.classList.add(
        'hidden'
    );

    tagMembersLoading.classList.remove(
        'hidden'
    );

    tagMembersLoading.classList.add(
        'flex'
    );

    const url = new URL(
        currentEligibleMembersUrl,
        window.location.origin
    );

    const normalizedSearch =
        search.trim();

    if (normalizedSearch !== '') {
        url.searchParams.set(
            'q',
            normalizedSearch
        );
    }

    try {
        const response = await fetch(
            url.toString(),
            {
                method: 'GET',

                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',
                },
            }
        );

        const data =
            await response.json();

        if (!response.ok) {
            throw new Error(
                data.message
                || 'Eligible friends could not be loaded.'
            );
        }

        if (
            requestNumber
            !== tagMembersRequestNumber
        ) {
            return;
        }

        const members =
            Array.isArray(data.members)
                ? data.members
                : [];

        renderTaggableMembers(
            members
        );
    } catch (error) {
        if (
            requestNumber
            !== tagMembersRequestNumber
        ) {
            return;
        }

        showTagMembersError(
            error.message
            || 'Eligible friends could not be loaded.'
        );
    } finally {
        if (
            requestNumber
            === tagMembersRequestNumber
        ) {
            tagMembersLoading
                .classList
                .add('hidden');

            tagMembersLoading
                .classList
                .remove('flex');
        }
    }
};

/*
|--------------------------------------------------------------------------
| Photo tag placement
|--------------------------------------------------------------------------
*/

const clearTagPlacement = () => {
    placementMode = false;

    pendingTagPosition = null;

    image?.classList.remove(
        'cursor-crosshair'
    );

    tagPlacementMarker?.classList.add(
        'hidden'
    );

    tagOpenButton?.classList.remove(
        'ring-2',
        'ring-cyan-200'
    );

    if (tagOpenButton) {
        tagOpenButton.textContent =
            '+ Tag Friend';
    }
};

const showTagPlacementMarker = (
    xPercent,
    yPercent
) => {
    if (!tagPlacementMarker) {
        return;
    }

    tagPlacementMarker.style.left =
        `${xPercent}%`;

    tagPlacementMarker.style.top =
        `${yPercent}%`;

    tagPlacementMarker.classList.remove(
        'hidden'
    );
};

const clearPhotoTagMarkers = () => {
    if (!tagOverlay) {
        return;
    }

    tagOverlay.innerHTML = '';
};

const positionPhotoTagMarker = (
    marker,
    tag
) => {
    if (
        !image
        || !tagOverlay
        || tag.x_percent === null
        || tag.y_percent === null
    ) {
        return;
    }

    const imageRect =
        image.getBoundingClientRect();

    const overlayRect =
        tagOverlay.getBoundingClientRect();

    if (
        imageRect.width <= 0
        || imageRect.height <= 0
        || overlayRect.width <= 0
        || overlayRect.height <= 0
    ) {
        return;
    }

    const xPercent =
        Math.min(
            100,
            Math.max(
                0,
                Number(tag.x_percent)
            )
        );

    const yPercent =
        Math.min(
            100,
            Math.max(
                0,
                Number(tag.y_percent)
            )
        );

    const xInViewport =
        imageRect.left
        + (
            imageRect.width
            * xPercent
            / 100
        );

    const yInViewport =
        imageRect.top
        + (
            imageRect.height
            * yPercent
            / 100
        );

    const leftPercent =
        (
            (
                xInViewport
                - overlayRect.left
            )
            / overlayRect.width
        ) * 100;

    const topPercent =
        (
            (
                yInViewport
                - overlayRect.top
            )
            / overlayRect.height
        ) * 100;

    marker.style.left =
        `${leftPercent}%`;

    marker.style.top =
        `${topPercent}%`;
};

const createPhotoTagMarker = (
    tag
) => {
    const member =
        tag.member ?? {};

    const marker =
        member.profile_url
            ? document.createElement(
                'a'
            )
            : document.createElement(
                'button'
            );

    marker.className =
        'pointer-events-auto absolute z-10 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-cyan-400 text-xs font-black text-slate-950 shadow-lg shadow-black/50 transition hover:scale-110 focus:outline-none focus:ring-2 focus:ring-cyan-200 focus:ring-offset-2 focus:ring-offset-black';

    marker.dataset.photoTagMarkerId =
        String(tag.id);

    marker.setAttribute(
        'aria-label',
        `View ${
            member.name
            || 'tagged member'
        }`
    );

    marker.title =
        member.name
        || 'Tagged member';

    if (
        marker instanceof
            HTMLAnchorElement
        && member.profile_url
    ) {
        marker.href =
            member.profile_url;
    }

    if (
        marker instanceof
            HTMLButtonElement
    ) {
        marker.type = 'button';
    }

    if (member.profile_photo_url) {
        const avatar =
            document.createElement(
                'img'
            );

        avatar.src =
            member.profile_photo_url;

        avatar.alt = '';

        avatar.className =
            'h-full w-full rounded-full object-cover';

        marker.appendChild(
            avatar
        );
    } else {
        marker.textContent =
            member.initials
            || '?';
    }

    /*
     * The label must be created only after
     * member and marker have been defined.
     */
    const label =
        document.createElement(
            'span'
        );

    label.className =
        'pointer-events-none absolute left-1/2 top-full mt-2 hidden -translate-x-1/2 whitespace-nowrap rounded-lg bg-slate-950/95 px-3 py-2 text-xs font-black text-white shadow-xl ring-1 ring-white/10';

    label.dataset.photoTagLabel =
        'true';

    label.textContent =
        member.name
        || 'Tagged member';

    marker.appendChild(
        label
    );

    marker.addEventListener(
        'click',
        (event) => {
            if (
                marker instanceof
                    HTMLAnchorElement
            ) {
                event.preventDefault();
            }

            event.stopPropagation();

            togglePhotoTagLabel(
                marker
            );
        }
    );

    marker.addEventListener(
        'focus',
        () => {
            closeOpenTagLabels(
                marker
            );

            label.classList.remove(
                'hidden'
            );
        }
    );

    marker.addEventListener(
        'blur',
        () => {
            label.classList.add(
                'hidden'
            );
        }
    );

    positionPhotoTagMarker(
        marker,
        tag
    );

    return marker;
};

const renderPhotoTagMarkers = (
    tags
) => {
    clearPhotoTagMarkers();

    if (!tagOverlay) {
        return;
    }

    tags
        .filter((tag) => {
            return (
                tag.x_percent !== null
                && tag.y_percent !== null
            );
        })
        .forEach((tag) => {
            tagOverlay.appendChild(
                createPhotoTagMarker(
                    tag
                )
            );
        });

const positionedTagCount =
    tags.filter(
        (tag) =>
            tag.x_percent !== null
            && tag.y_percent !== null
    ).length;

tagToggleButton?.classList.toggle(
    'hidden',
    positionedTagCount === 0
);

renderPhotoTagVisibility();
};

const repositionPhotoTagMarkers = () => {
    if (!tagOverlay) {
        return;
    }

    currentPhotoTags.forEach(
        (tag) => {
            const marker =
                tagOverlay.querySelector(
                    `[data-photo-tag-marker-id="${tag.id}"]`
                );

            if (!(marker instanceof HTMLElement)) {
                return;
            }

            positionPhotoTagMarker(
                marker,
                tag
            );
        }
    );
};

const beginTagPlacement = () => {
    slideshow.pause();

    if (
        !image
        || !currentEligibleMembersUrl
        || !currentTagStoreUrl
    ) {
        showTagsError(
            'Photo tagging is unavailable right now.'
        );

        return;
    }

    closeTagPicker();

    clearTagsError();

    placementMode = true;

    pendingTagPosition = null;

    image.classList.add(
        'cursor-crosshair'
    );

    tagOpenButton?.classList.add(
        'ring-2',
        'ring-cyan-200'
    );

    if (tagOpenButton) {
        tagOpenButton.textContent =
            'Click Person in Photo';
    }
};

const selectTagPosition = (
    event
) => {
    if (
        !placementMode
        || !image
        || !tagOverlay
    ) {
        return;
    }

    const imageRect =
        image.getBoundingClientRect();

    /*
     * The image uses object-contain and may not fill its
     * entire parent. Only accept clicks inside the actual
     * rendered image rectangle.
     */
    const clickedInsideImage =
        event.clientX >= imageRect.left
        && event.clientX <= imageRect.right
        && event.clientY >= imageRect.top
        && event.clientY <= imageRect.bottom;

    if (!clickedInsideImage) {
        return;
    }

    event.preventDefault();

    event.stopPropagation();

    const xPercent =
        Math.min(
            100,
            Math.max(
                0,
                (
                    (
                        event.clientX
                        - imageRect.left
                    )
                    / imageRect.width
                ) * 100
            )
        );

    const yPercent =
        Math.min(
            100,
            Math.max(
                0,
                (
                    (
                        event.clientY
                        - imageRect.top
                    )
                    / imageRect.height
                ) * 100
            )
        );

    pendingTagPosition = {
        xPercent:
            Number(
                xPercent.toFixed(2)
            ),

        yPercent:
            Number(
                yPercent.toFixed(2)
            ),
    };

    /*
     * The marker is positioned relative to the photo-area
     * container, so convert the image-relative percentages
     * back into container-relative coordinates.
     */
    const overlayRect =
        tagOverlay
            .getBoundingClientRect();

    const markerXPercent =
        (
            (
                event.clientX
                - overlayRect.left
            )
            / overlayRect.width
        ) * 100;

    const markerYPercent =
        (
            (
                event.clientY
                - overlayRect.top
            )
            / overlayRect.height
        ) * 100;

    showTagPlacementMarker(
        markerXPercent,
        markerYPercent
    );

    placementMode = false;

    image.classList.remove(
        'cursor-crosshair'
    );

    tagOpenButton?.classList.remove(
        'ring-2',
        'ring-cyan-200'
    );

    if (tagOpenButton) {
        tagOpenButton.textContent =
            '+ Tag Friend';
    }

    openTagPicker();
};

const openTagPicker = () => {
    slideshow.pause();

    if (
        !tagPicker
        || !currentEligibleMembersUrl
        || !currentTagStoreUrl
    ) {
        showTagsError(
            'The friend tag picker is unavailable right now.'
        );

        return;
    }

    if (!pendingTagPosition) {
        beginTagPlacement();

        return;
    }

    clearTagsError();

    tagPicker.classList.remove(
        'hidden'
    );

    loadTaggableMembers();

    window.requestAnimationFrame(
        () => {
            tagSearch?.focus();
        }
    );
};

const storePhotoTag = async (
    memberId,
    button
) => {
    if (!currentTagStoreUrl) {
        showTagMembersError(
            'This friend cannot be tagged right now.'
        );

        return;
    }

    if (!csrfToken) {
        showTagMembersError(
            'Your security token is missing. Refresh the page and try again.'
        );

        return;
    }

    clearTagMembersError();

    button.disabled = true;

    const originalText =
        button.textContent;

    button.textContent =
        'Tagging...';

    try {
        const response = await fetch(
            currentTagStoreUrl,
            {
                method: 'POST',

                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'Content-Type':
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',

                    'X-CSRF-TOKEN':
                        csrfToken,
                },

                body: JSON.stringify({
    tagged_user_id:
        Number(memberId),

    x_percent:
        pendingTagPosition
            ?.xPercent
        ?? null,

    y_percent:
        pendingTagPosition
            ?.yPercent
        ?? null,
}),
            }
        );

        if (response.status === 401) {
            const activePhoto =
                getPhotoData(
                    triggers[currentIndex]
                );

            window.location.href =
                activePhoto.loginUrl;

            return;
        }

        if (response.status === 419) {
            throw new Error(
                'Your session expired. Refresh the page and try again.'
            );
        }

        const data =
            await response.json();

        if (!response.ok) {
            const validationMessage =
                data.errors
                    ?.tagged_user_id
                    ?.[0];

            throw new Error(
                validationMessage
                || data.message
                || 'The friend could not be tagged.'
            );
        }

        button.textContent =
            'Tagged';

        button.className =
            'shrink-0 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-xs font-black text-slate-500 disabled:cursor-not-allowed disabled:opacity-60';

        button.disabled = true;

        const activePhoto =
            getPhotoData(
                triggers[currentIndex]
            );

        await loadPhotoTags(
            activePhoto
        );
closeTagPicker();

clearTagPlacement();
    } catch (error) {
        button.disabled = false;

        button.textContent =
            originalText;

        showTagMembersError(
            error.message
            || 'The friend could not be tagged.'
        );
    }
};

const removePhotoTag = async (
    button
) => {
    const deleteUrl =
        button.dataset
            .photoTagRemove;

    if (!deleteUrl) {
        showTagsError(
            'This photo tag cannot be removed right now.'
        );

        return;
    }

    if (!csrfToken) {
        showTagsError(
            'Your security token is missing. Refresh the page and try again.'
        );

        return;
    }

    clearTagsError();

    button.disabled = true;

    const originalText =
        button.textContent;

    button.textContent =
        'Removing...';

    try {
        const response = await fetch(
            deleteUrl,
            {
                method: 'DELETE',

                credentials:
                    'same-origin',

                headers: {
                    Accept:
                        'application/json',

                    'X-Requested-With':
                        'XMLHttpRequest',

                    'X-CSRF-TOKEN':
                        csrfToken,
                },
            }
        );

        if (response.status === 401) {
            const activePhoto =
                getPhotoData(
                    triggers[currentIndex]
                );

            window.location.href =
                activePhoto.loginUrl;

            return;
        }

        if (response.status === 419) {
            throw new Error(
                'Your session expired. Refresh the page and try again.'
            );
        }

        const data =
            await response.json();

        if (!response.ok) {
            throw new Error(
                data.message
                || 'The photo tag could not be removed.'
            );
        }

        const article =
            button.closest(
                '[data-photo-tag-id]'
            );

        article?.remove();

const removedTagId =
    article?.dataset.photoTagId;

if (removedTagId) {
    tagOverlay
        ?.querySelector(
            `[data-photo-tag-marker-id="${removedTagId}"]`
        )
        ?.remove();

    currentPhotoTags =
        currentPhotoTags.filter(
            (tag) =>
                String(tag.id)
                !== String(
                    removedTagId
                )
        );
}

        const remainingTags =
            tagsList
                ? tagsList.querySelectorAll(
                    '[data-photo-tag-id]'
                ).length
                : parseCount(
                    data.tag_count
                );

        if (tagCount) {
            tagCount.textContent =
                formatTagCount(
                    data.tag_count
                    ?? remainingTags
                );
        }

        tagsEmpty?.classList.toggle(
            'hidden',
            remainingTags > 0
        );

        /*
         * Refresh the eligible-member picker so the
         * removed member becomes taggable again.
         */
        if (
            tagPicker
            && !tagPicker.classList
                .contains('hidden')
        ) {
            await loadTaggableMembers(
                tagSearch?.value
                ?? ''
            );
        }
    } catch (error) {
        button.disabled = false;

        button.textContent =
            originalText;

        showTagsError(
            error.message
            || 'The photo tag could not be removed.'
        );
    }
};

    /*
    |--------------------------------------------------------------------------
    | Photo rendering
    |--------------------------------------------------------------------------
    */


    const showPhoto = (index) => {
        if (triggers.length === 0) return;
        if (index < 0) {
            index =
                triggers.length - 1;
        }

        if (
            index >= triggers.length
        ) {
            index = 0;
        }

        currentIndex = index;
				
				reactionsRequestNumber++;

reactionsNextPageUrl = null;

activeReactionFilter = null;

loadedReactionsPhotoId = null;

commentsRequestNumber++;

commentsNextPageUrl = null;

loadedCommentsPhotoId = null;
resetPhotoTags();

if (commentsList) {
    commentsList.innerHTML = '';
}

commentsEmpty?.classList.add(
    'hidden'
);

commentsMoreButton?.classList.add(
    'hidden'
);

commentsLoading?.classList.add(
    'hidden'
);

commentsLoading?.classList.remove(
    'flex'
);

clearCommentsError(
    commentsError
);

if (reactionsList) {
    reactionsList.innerHTML = '';
}

reactionsEmpty?.classList.add(
    'hidden'
);

reactionsMoreButton?.classList.add(
    'hidden'
);

clearReactionsError(
    reactionsError
);

        activateSidebarTab('info');

if (activeCommentEditArticle) {
    cancelCommentEdit(
        activeCommentEditArticle
    );
}

        const photo = getPhotoData(
            triggers[currentIndex]
        );

        modal.dispatchEvent(new CustomEvent('festival-photo:shown', { detail: { trigger: triggers[currentIndex] } }));

if (!triggers[currentIndex].dataset.photoStatus || triggers[currentIndex].dataset.photoStatus === 'approved') {
    loadPhotoTags(photo);
}

        const detailParts = [
            photo.year,
            photo.location,
        ].filter(Boolean);

        if (image) {
    image.classList.add(
        'opacity-0'
    );

    loading?.classList.remove(
        'hidden'
    );

    loading?.classList.add(
        'flex'
    );

    image.alt =
        photo.caption
        || `Festival photo uploaded by ${photo.uploader}`;

    image.src =
        photo.url;

    if (
        image.complete
        && image.naturalWidth > 0
    ) {
        loading?.classList.add(
            'hidden'
        );

        loading?.classList.remove(
            'flex'
        );

        requestAnimationFrame(
            () => {
                image.classList.remove(
                    'opacity-0'
                );
            }
        );
    }
}

        if (uploader) {
            uploader.textContent =
                photo.uploader;
        }

        setOptionalText(
            detailsWrapper,
            details,
            detailParts.join(' · ')
        );

        setOptionalText(
            takenWrapper,
            takenAt,
            photo.takenAt
        );

        setOptionalText(
            captionWrapper,
            caption,
            photo.caption
        );

        if (position) {
            position.textContent =
                `Photo ${currentIndex + 1} of ${triggers.length}`;
        }

        renderReactionControls(
            photo
        );

        if (modalCommentCount) {
            modalCommentCount.textContent =
                formatCommentText(
                    photo.commentCount
                );
        }

        clearCommentsError(
    commentsError
);

        clearCommentFormError(
    commentFormError
);

        commentsNextPageUrl = null;

        if (commentBody) {
            commentBody.value = '';
        }

        if (photo.authenticated) {
            commentForm?.classList.remove(
                'hidden'
            );

            commentLoginLink?.classList.add(
                'hidden'
            );

            commentLoginLink?.classList.remove(
                'flex'
            );

            if (commentForm) {
                commentForm.action =
                    photo.commentStoreUrl;
            }
        } else {
            commentForm?.classList.add(
                'hidden'
            );

            if (commentLoginLink) {
                commentLoginLink.href =
                    photo.loginUrl;

                commentLoginLink
                    .classList
                    .remove('hidden');

                commentLoginLink
                    .classList
                    .add('flex');
            }
        }

     
        const hasMultiplePhotos =
            triggers.length > 1;

        previousButton?.classList.toggle(
            'hidden',
            !hasMultiplePhotos
        );

        nextButton?.classList.toggle(
            'hidden',
            !hasMultiplePhotos
        );

slideshow.setAvailable(
    hasMultiplePhotos
);

preloadAdjacentPhotos(
    triggers,
    currentIndex
);

slideshow.restart();

    };

/*
|--------------------------------------------------------------------------
| Deep linking
|--------------------------------------------------------------------------
*/

const openPhotoFromUrl = () => {
    const params =
        new URLSearchParams(
            window.location.search
        );

    const requestedPhotoId =
        params.get('photo');

    if (!requestedPhotoId) {
        return;
    }

    const index =
        triggers.findIndex(
            (trigger) =>
                trigger.dataset
                    .photoId ===
                requestedPhotoId
        );

    if (index === -1) {
        return;
    }

    openModal(index);

    /*
     * Remove the query parameter so refreshing
     * the page doesn't reopen the modal.
     */
const hash =
    window.location.hash;

if (
    hash.startsWith(
        '#photo-comment-'
    )
) {
    window.setTimeout(
        () => {
            const target =
                document.querySelector(
                    hash
                );

            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });

                target.classList.add(
                    'ring-2',
                    'ring-cyan-400'
                );

                window.setTimeout(
                    () => {
                        target.classList.remove(
                            'ring-2',
                            'ring-cyan-400'
                        );
                    },
                    2500
                );
            }
        },
        300
    );
}
    params.delete('photo');

    const query =
        params.toString();

    const newUrl =
        query === ''
            ? window.location.pathname
            : `${window.location.pathname}?${query}`;

    window.history.replaceState(
        {},
        '',
        newUrl
    );
};
const slideshow =
    createPhotoSlideshow({
        button:
            slideshowButton,

		progress:
            slideshowProgress,

        intervalMilliseconds:
            5000,

        onAdvance: () => {
            showPhoto(
                currentIndex + 1
            );
        },
    });
    /*
    |--------------------------------------------------------------------------
    | Modal open and close
    |--------------------------------------------------------------------------
    */



const resetPhotoSwipe = () => {
    swipeStartX = null;

    swipeStartY = null;

    swipePointerId = null;

    swipeStartedOnPhoto = false;
};

const isPhotoSwipeTarget = (
    target
) => {
    if (!(target instanceof Element)) {
        return false;
    }

    return Boolean(
        target.closest(
            '[data-photo-modal-image]'
        )
    );
};

const beginPhotoSwipe = (
    event
) => {

if (placementMode) {
    resetPhotoSwipe();

    return;
}
    if (
        event.pointerType === 'mouse'
        || modal.classList.contains(
            'hidden'
        )
        || !isPhotoSwipeTarget(
            event.target
        )
    ) {
        resetPhotoSwipe();

        return;
    }

    swipeStartX =
        event.clientX;

    swipeStartY =
        event.clientY;

    swipePointerId =
        event.pointerId;

    swipeStartedOnPhoto =
        true;
};

const finishPhotoSwipe = (
    event
) => {
    if (
        !swipeStartedOnPhoto
        || swipePointerId
            !== event.pointerId
        || swipeStartX === null
        || swipeStartY === null
    ) {
        resetPhotoSwipe();

        return;
    }

    const horizontalDistance =
        event.clientX - swipeStartX;

    const verticalDistance =
        event.clientY - swipeStartY;

    const absoluteHorizontalDistance =
        Math.abs(
            horizontalDistance
        );

    const absoluteVerticalDistance =
        Math.abs(
            verticalDistance
        );

    const minimumSwipeDistance = 60;

    const isHorizontalSwipe =
        absoluteHorizontalDistance
            >= minimumSwipeDistance
        && absoluteHorizontalDistance
            > absoluteVerticalDistance * 1.25;

    resetPhotoSwipe();

    if (!isHorizontalSwipe) {
        return;
    }

	slideshow.pause();

    if (horizontalDistance < 0) {
        showPhoto(
            currentIndex + 1
        );

        return;
    }

    showPhoto(
        currentIndex - 1
    );
};

    const openModal = (index) => {
        previousActiveElement =
            document.activeElement;

        showPhoto(index);

        modal.classList.remove(
            'hidden'
        );

        document.body.classList.add(
            'overflow-hidden'
        );

        modal
            .querySelector(
                '[data-photo-modal-close]'
            )
            ?.focus();
    };

    const closeModal = () => {
slideshow.stop();
        closeCommentDeleteModal();

if (activeCommentEditArticle) {
    cancelCommentEdit(
        activeCommentEditArticle
    );
}

        modal.classList.add(
            'hidden'
        );

        document.body.classList.remove(
            'overflow-hidden'
        );

        if (image) {
            image.src = '';
        }

        clearReactionError(
    reactionError
);

        commentsRequestNumber++;

        commentsNextPageUrl = null;

        if (commentsList) {
            commentsList.innerHTML = '';
        }

        clearCommentsError(
    commentsError
);

        clearCommentFormError(
    commentFormError
);

reactionsRequestNumber++;

reactionsNextPageUrl = null;

activeReactionFilter = null;

loadedReactionsPhotoId = null;

if (reactionsList) {
    reactionsList.innerHTML = '';
}

clearReactionsError(
    reactionsError
);

        if (
            previousActiveElement
            && typeof previousActiveElement
                .focus === 'function'
        ) {
            previousActiveElement.focus();
        }
    };

    /*
    |--------------------------------------------------------------------------
    | Sidebar tab events
    |--------------------------------------------------------------------------
    */

    sidebarTabs.forEach(
        (tab, index) => {
            tab.addEventListener(
                'click',
                () => {
                    activateSidebarTab(
                        tab.dataset.photoModalTab
                    );
                }
            );

            tab.addEventListener(
                'keydown',
                (event) => {
                    if (
                        event.key !== 'ArrowLeft'
                        && event.key !== 'ArrowRight'
                        && event.key !== 'Home'
                        && event.key !== 'End'
                    ) {
                        return;
                    }

                    event.preventDefault();

                    let nextIndex = index;

                    if (event.key === 'ArrowRight') {
                        nextIndex =
                            (index + 1)
                            % sidebarTabs.length;
                    }

                    if (event.key === 'ArrowLeft') {
                        nextIndex =
                            (
                                index
                                - 1
                                + sidebarTabs.length
                            )
                            % sidebarTabs.length;
                    }

                    if (event.key === 'Home') {
                        nextIndex = 0;
                    }

                    if (event.key === 'End') {
                        nextIndex =
                            sidebarTabs.length - 1;
                    }

                    const nextTab =
                        sidebarTabs[nextIndex];

                    activateSidebarTab(
                        nextTab.dataset.photoModalTab,
                        true
                    );
                }
            );
        }
    );

/*
|--------------------------------------------------------------------------
| Photo swipe navigation
|--------------------------------------------------------------------------
*/
image?.addEventListener(
    'click',
    selectTagPosition
);
image?.addEventListener(
    'pointerdown',
    beginPhotoSwipe
);

image?.addEventListener(
    'pointerup',
    finishPhotoSwipe
);

image?.addEventListener(
    'pointercancel',
    resetPhotoSwipe
);

image?.addEventListener(
    'lostpointercapture',
    resetPhotoSwipe
);

    /*
    |--------------------------------------------------------------------------
    | Image loading events
    |--------------------------------------------------------------------------
    */

    image?.addEventListener(
        'load',
        () => {
            loading?.classList.add(
                'hidden'
            );

            loading?.classList.remove(
                'flex'
            );

            image.classList.remove(
                'opacity-0'
            );
			window.requestAnimationFrame(
    () => {
        repositionPhotoTagMarkers();
    }
);
        }
    );

    image?.addEventListener(
        'error',
        () => {
            loading?.classList.add(
                'hidden'
            );

            loading?.classList.remove(
                'flex'
            );

            image.classList.remove(
                'opacity-0'
            );

            image.alt =
                'The festival photo could not be loaded.';
        }
    );

    /*
    |--------------------------------------------------------------------------
    | Photo trigger events
    |--------------------------------------------------------------------------
    */
reactionFilters?.addEventListener(
    'click',
    (event) => {
        const target =
            event.target;

        if (
            !(target instanceof Element)
        ) {
            return;
        }

        const filterButton =
            target.closest(
                '[data-photo-reaction-filter]'
            );

        if (
            !filterButton
            || filterButton.disabled
        ) {
            return;
        }

        const requestedFilter =
            filterButton.dataset
                .photoReactionFilter
            || null;

        if (
            activeReactionFilter
            === requestedFilter
        ) {
            return;
        }

        activeReactionFilter =
            requestedFilter;

        loadedReactionsPhotoId =
            null;

        loadCurrentPhotoReactions();
    }
);

/*
|--------------------------------------------------------------------------
| Photo tag picker events
|--------------------------------------------------------------------------
*/

tagOpenButton?.addEventListener(
    'click',
    openTagPicker
);

tagCloseButton?.addEventListener(
    'click',
    closeTagPicker
);

tagSearch?.addEventListener(
    'input',
    () => {
        if (
            tagSearchTimeoutId !== null
        ) {
            window.clearTimeout(
                tagSearchTimeoutId
            );
        }

        tagSearchTimeoutId =
            window.setTimeout(
                () => {
                    tagSearchTimeoutId =
                        null;

                    loadTaggableMembers(
                        tagSearch.value
                    );
                },
                300
            );
    }
);

tagMembersList?.addEventListener(
    'click',
    (event) => {
        const target =
            event.target;

        if (
            !(target instanceof Element)
        ) {
            return;
        }

        const button =
            target.closest(
                '[data-photo-tag-member]'
            );

        if (
            !(button instanceof
                HTMLButtonElement)
            || button.disabled
        ) {
            return;
        }

        const memberId =
            button.dataset
                .photoTagMember;

        if (!memberId) {
            return;
        }

        storePhotoTag(
            memberId,
            button
        );
    }
);

tagsList?.addEventListener(
    'click',
    (event) => {
        const target =
            event.target;

        if (
            !(target instanceof Element)
        ) {
            return;
        }

        const button =
            target.closest(
                '[data-photo-tag-remove]'
            );

        if (
            !(button instanceof
                HTMLButtonElement)
            || button.disabled
        ) {
            return;
        }

        removePhotoTag(
            button
        );
    }
);

reactionsMoreButton?.addEventListener(
    'click',
    () => {
        if (reactionsNextPageUrl) {
            loadReactionMembers(
                reactionsNextPageUrl,
                true
            );
        }
    }
);

    listenDocument(
    'click',
    (event) => {
        const target = event.target;

        if (!(target instanceof Element)) {
            return;
        }

        const trigger = target.closest(
            '.festival-photo-lightbox-trigger'
        );

        if (!trigger) {
            return;
        }

        event.preventDefault();

        refreshPhotoTriggers();

        const index =
            triggers.findIndex((item) => item.dataset.photoId === trigger.dataset.photoId);

        if (index === -1) {
            return;
        }

        openModal(index);
    }
);

listenDocument(
    'festival-photos:updated',
    refreshPhotoTriggers
);

    closeButtons.forEach(
        (button) => {
            button.addEventListener(
                'click',
                closeModal
            );
        }
    );

    previousButton?.addEventListener(
    'click',
    () => {
        slideshow.pause();

        showPhoto(
            currentIndex - 1
        );
    }
);

    nextButton?.addEventListener(
    'click',
    () => {
        showPhoto(
            currentIndex + 1
        );
    }
);

    /*
    |--------------------------------------------------------------------------
    | Like submission
    |--------------------------------------------------------------------------
    */

    reactionChoiceButtons.forEach(
    (button) => {
        button.addEventListener(
            'click',
            async () => {
                const activePhoto =
                    getPhotoData(
                        triggers[
                            currentIndex
                        ]
                    );

                const requestedReaction =
                    button.dataset
                        .photoReactionChoice;

                if (
                    !activePhoto.authenticated
                ) {
                    window.location.href =
                        activePhoto.loginUrl;

                    return;
                }

                if (
                    !activePhoto.reactionUrl
                    || !requestedReaction
                ) {
                    showReactionError(
    reactionError,
    'Reactions are unavailable for this photo.'
);

                    return;
                }

                if (!csrfToken) {
                    showReactionError(
    reactionError,
    'Your security token is missing. Refresh the page and try again.'
);

                    return;
                }

               clearReactionError(
    reactionError
);

                reactionChoiceButtons.forEach(
                    (choiceButton) => {
                        choiceButton.disabled =
                            true;
                    }
                );

                try {
                    const response =
                        await fetch(
                            activePhoto
                                .reactionUrl,
                            {
                                method:
                                    'POST',

                                credentials:
                                    'same-origin',

                                headers: {
                                    Accept:
                                        'application/json',

                                    'Content-Type':
                                        'application/json',

                                    'X-Requested-With':
                                        'XMLHttpRequest',

                                    'X-CSRF-TOKEN':
                                        csrfToken,
                                },

                                body:
                                    JSON.stringify({
                                        reaction:
                                            requestedReaction,
                                    }),
                            }
                        );

                    if (
                        response.status
                        === 401
                    ) {
                        window.location.href =
                            activePhoto
                                .loginUrl;

                        return;
                    }

                    if (
                        response.status
                        === 419
                    ) {
                        throw new Error(
                            'Your session expired. Refresh the page and try again.'
                        );
                    }

                    const data =
                        await response.json();

                    if (!response.ok) {
                        const validationMessage =
                            data.errors
                                ?.reaction?.[0];

                        throw new Error(
                            validationMessage
                            || data.message
                            || 'Your reaction could not be saved.'
                        );
                    }

                    updatePhotoReactionState(
    activePhoto.id,
    data
);

clearPhotoReactionCache(
    activePhoto.id
);

loadedReactionsPhotoId = null;

activateSidebarTab(
    'reactions'
);
                } catch (error) {
                    showReactionError(
    reactionError,
    error.message
    || 'Your reaction could not be saved.'
);
                } finally {
                    reactionChoiceButtons.forEach(
                        (choiceButton) => {
                            choiceButton.disabled =
                                false;
                        }
                    );
                }
            }
        );
    }
);

    /*
    |--------------------------------------------------------------------------
    | Load additional comments
    |--------------------------------------------------------------------------
    */

    commentsMoreButton?.addEventListener(
        'click',
        () => {
            if (
                commentsNextPageUrl
            ) {
                const activePhoto =
    getPhotoData(
        triggers[currentIndex]
    );

loadComments(
    commentsNextPageUrl,
    true,
    activePhoto.id
);
            }
        }
    );

    /*
    |--------------------------------------------------------------------------
    | Comment submission
    |--------------------------------------------------------------------------
    */
commentBody?.addEventListener(
    'focus',
    () => {
        slideshow.pause();
    }
);

commentBody?.addEventListener(
    'input',
    () => {
        scheduleMentionSearch();
    }
);

commentBody?.addEventListener(
    'click',
    () => {
        scheduleMentionSearch();
    }
);

commentBody?.addEventListener(
    'keyup',
    (event) => {
        if (
            [
                'ArrowUp',
                'ArrowDown',
                'Enter',
                'Tab',
                'Escape',
            ].includes(event.key)
        ) {
            return;
        }

        scheduleMentionSearch();
    }
);

commentBody?.addEventListener(
    'keydown',
    (event) => {
        const resultsVisible =
            mentionResults
            && !mentionResults
                .classList
                .contains('hidden');

        if (!resultsVisible) {
            return;
        }

        if (
            event.key
            === 'ArrowDown'
        ) {
            event.preventDefault();

            setActiveMentionIndex(
                activeMentionIndex + 1
            );

            return;
        }

        if (
            event.key
            === 'ArrowUp'
        ) {
            event.preventDefault();

            setActiveMentionIndex(
                activeMentionIndex - 1
            );

            return;
        }

        if (
            (
                event.key === 'Enter'
                || event.key === 'Tab'
            )
            && activeMentionIndex >= 0
        ) {
            event.preventDefault();

            insertMentionMember(
                mentionMembers[
                    activeMentionIndex
                ]
            );

            return;
        }

        if (
            event.key
            === 'Escape'
        ) {
            event.preventDefault();

            closeMentionResults();
        }
    }
);

    commentForm?.addEventListener(
        'submit',
        async (event) => {
            event.preventDefault();

            const activePhoto =
                getPhotoData(
                    triggers[
                        currentIndex
                    ]
                );

            const body =
                commentBody
                    ?.value
                    .trim()
                ?? '';

            if (
                !activePhoto
                    .authenticated
            ) {
                window.location.href =
                    activePhoto.loginUrl;

                return;
            }

            if (!body) {
    showCommentFormError(
        commentFormError,
        'Please enter a comment.'
    );

    commentBody?.focus();

    return;
}

            if (
                !activePhoto
                    .commentStoreUrl
            ) {
                showCommentFormError(
    commentFormError,
    'Comments are unavailable for this photo.'
);

                return;
            }

            if (!csrfToken) {
    showCommentFormError(
        commentFormError,
        'Your security token is missing. Refresh the page and try again.'
    );

    return;
}

            clearCommentFormError(
    commentFormError
);

            if (
                commentSubmitButton
            ) {
                commentSubmitButton
                    .disabled =
                    true;

                commentSubmitButton
                    .textContent =
                    'Posting...';
            }

            try {
                const response =
                    await fetch(
                        activePhoto
                            .commentStoreUrl,
                        {
                            method: 'POST',

                            credentials:
                                'same-origin',

                            headers: {
                                Accept:
                                    'application/json',

                                'Content-Type':
                                    'application/json',

                                'X-Requested-With':
                                    'XMLHttpRequest',

                                'X-CSRF-TOKEN':
                                    csrfToken,
                            },

                            body:
                                JSON.stringify({
                                    body,
                                }),
                        }
                    );

                if (
                    response.status === 401
                ) {
                    window.location.href =
                        activePhoto
                            .loginUrl;

                    return;
                }

                if (
                    response.status === 419
                ) {
                    throw new Error(
                        'Your session expired. Refresh the page and try again.'
                    );
                }

                const data =
                    await response.json();

                if (!response.ok) {
                    const validationMessage =
                        data.errors
                            ?.body?.[0];

                    throw new Error(
                        validationMessage
                        || data.message
                        || 'Your comment could not be posted.'
                    );
                }

                addCommentToCache(
    activePhoto.id,
    data.comment,
    data.comment_count
);

const updatedCache =
    getCachedComments(
        activePhoto.id
    );

if (updatedCache?.hasMorePages) {
    commentsMoreButton
        ?.classList
        .add('hidden');
}

loadedCommentsPhotoId =
    String(activePhoto.id);

if (commentsList) {
    const commentElement =
        createCommentElement(
            data.comment
        );

    if (commentsList.firstChild) {
        commentsList.insertBefore(
            commentElement,
            commentsList.firstChild
        );
    } else {
        commentsList.appendChild(
            commentElement
        );
    }
}

activateSidebarTab(
    'comments'
);

                commentsEmpty?.classList.add(
                    'hidden'
                );

                if (commentBody) {
                    commentBody.value = '';
                }

closeMentionResults();

                updatePhotoCommentCount(
                    activePhoto.id,

                    parseCount(
                        data.comment_count
                    )
                );

                commentsList
                    ?.lastElementChild
                    ?.scrollIntoView({
                        behavior:
                            'smooth',

                        block:
                            'nearest',
                    });
            } catch (error) {
                showCommentFormError(
    commentFormError,
    error.message
    || 'Your comment could not be posted.'
);
            } finally {
                if (
                    commentSubmitButton
                ) {
                    commentSubmitButton
                        .disabled =
                        false;

                    commentSubmitButton
                        .textContent =
                        'Post Comment';
                }
            }
        }
    );

    /*
    |--------------------------------------------------------------------------
    | Open comment deletion confirmation
    |--------------------------------------------------------------------------
    */

    commentsList?.addEventListener(
    'click',
    (event) => {
        const target =
            event.target;

        if (
            !(target instanceof Element)
        ) {
            return;
        }

        const article =
            target.closest(
                '[data-photo-comment-id]'
            );

        if (!article) {
            return;
        }

        const editButton =
            target.closest(
                '[data-photo-comment-edit]'
            );

        if (editButton) {
            beginCommentEdit(
                article
            );

            return;
        }

        const cancelButton =
            target.closest(
                '[data-photo-comment-edit-cancel]'
            );

        if (cancelButton) {
            cancelCommentEdit(
                article
            );

            return;
        }

        const saveButton =
            target.closest(
                '[data-photo-comment-edit-save]'
            );

        if (saveButton) {
            saveCommentEdit(
                article
            );

            return;
        }

        const deleteButton =
            target.closest(
                '[data-photo-comment-delete]'
            );

        if (deleteButton) {
            if (
                activeCommentEditArticle
                === article
            ) {
                cancelCommentEdit(
                    article
                );
            }

            openCommentDeleteModal(
                deleteButton
            );
        }
    }
);

commentsList?.addEventListener(
    'keydown',
    (event) => {
        const target =
            event.target;

        if (
            !(target instanceof
                HTMLTextAreaElement)
            || !target.matches(
                '[data-photo-comment-edit-body]'
            )
        ) {
            return;
        }

        const article =
            target.closest(
                '[data-photo-comment-id]'
            );

        if (!article) {
            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();

            cancelCommentEdit(
                article
            );

            return;
        }

        if (
            event.key === 'Enter'
            && (
                event.ctrlKey
                || event.metaKey
            )
        ) {
            event.preventDefault();

            saveCommentEdit(
                article
            );
        }
    }
);
    /*
    |--------------------------------------------------------------------------
    | Confirm comment deletion
    |--------------------------------------------------------------------------
    */

    commentDeleteConfirmButton
        ?.addEventListener(
            'click',
            async () => {
                if (
                    !pendingCommentDeleteButton
                ) {
                    return;
                }

                const deleteButton =
                    pendingCommentDeleteButton;

                const deleteUrl =
                    deleteButton.dataset
                        .photoCommentDelete;

                if (
                    !deleteUrl
                    || !csrfToken
                ) {
                    showCommentDeleteError(
    commentDeleteError,
    'This comment could not be deleted.'
);

                    return;
                }

               clearCommentDeleteError(
    commentDeleteError
);

commentDeleteConfirmButton.disabled = true;

                commentDeleteConfirmButton
                    .textContent =
                    'Deleting...';

                try {
                    const response =
                        await fetch(
                            deleteUrl,
                            {
                                method:
                                    'DELETE',

                                credentials:
                                    'same-origin',

                                headers: {
                                    Accept:
                                        'application/json',

                                    'X-Requested-With':
                                        'XMLHttpRequest',

                                    'X-CSRF-TOKEN':
                                        csrfToken,
                                },
                            }
                        );

                    if (
                        response.status
                        === 419
                    ) {
                        throw new Error(
                            'Your session expired. Refresh the page and try again.'
                        );
                    }

                    const data =
                        await response.json();

                    if (!response.ok) {
                        throw new Error(
                            data.message
                            || 'The comment could not be deleted.'
                        );
                    }

                    commentsList
                        ?.querySelector(
                            `[data-photo-comment-id="${data.comment_id}"]`
                        )
                        ?.remove();

                    const activePhoto =
    getPhotoData(
        triggers[
            currentIndex
        ]
    );

removeCommentFromCache(
    activePhoto.id,
    data.comment_id,
    data.comment_count
);

updatePhotoCommentCount(
    activePhoto.id,

    parseCount(
        data.comment_count
    )
);

				loadedCommentsPhotoId =
    String(activePhoto.id);

                    commentsEmpty
                        ?.classList
                        .toggle(
                            'hidden',

                            (
                                commentsList
                                    ?.children
                                    .length
                                ?? 0
                            ) > 0
                        );

                    closeCommentDeleteModal();
                } catch (error) {
                    showCommentDeleteError(
                        error.message
                        || 'The comment could not be deleted.'
                    );
                } finally {
                    commentDeleteConfirmButton
                        .disabled =
                        false;

                    commentDeleteConfirmButton
                        .textContent =
                        'Delete Comment';
                }
            }
        );

    /*
    |--------------------------------------------------------------------------
    | Cancel comment deletion
    |--------------------------------------------------------------------------
    */

    commentDeleteCancelButtons.forEach(
        (button) => {
            button.addEventListener(
                'click',
                closeCommentDeleteModal
            );
        }
    );

    /*
    |--------------------------------------------------------------------------
    | Keyboard controls
    |--------------------------------------------------------------------------
    */

    listenDocument(
        'keydown',
        (event) => {
            if (
                commentDeleteModal
                && !commentDeleteModal
                    .classList
                    .contains('hidden')
            ) {
                if (
                    event.key === 'Escape'
                ) {
                    closeCommentDeleteModal();
                }

                return;
            }

            if (
                modal.classList.contains(
                    'hidden'
                )
            ) {
                return;
            }

if (
    trapModalFocus(
        event,
        modal
    )
) {
    return;
}

            if (
                event.key === 'Escape'
            ) {
                closeModal();

                return;
            }

            const activeElement =
                document.activeElement;

            const isTyping =
                activeElement
                    instanceof HTMLInputElement
                || activeElement
                    instanceof HTMLTextAreaElement
                || activeElement
                    instanceof HTMLSelectElement
                || activeElement
                    ?.isContentEditable;

            if (isTyping) {
                return;
            }

const isSidebarTab =
    activeElement instanceof HTMLElement
    && activeElement.matches(
        '[data-photo-modal-tab]'
    );

if (isSidebarTab) {
    return;
}

if (event.key === 'Home') {
    event.preventDefault();

    showPhoto(0);

    return;
}

if (event.key === 'End') {
    event.preventDefault();

    showPhoto(
        triggers.length - 1
    );

    return;
}

            if (
                event.key === 'ArrowLeft'
            ) {

event.preventDefault();
slideshow.pause();
                showPhoto(
                    currentIndex - 1
                );

                return;
            }

            if (
                event.key === 'ArrowRight'
            ) {
event.preventDefault();
slideshow.pause();
                showPhoto(
                    currentIndex + 1
                );
            }
        }
    );

/*
|--------------------------------------------------------------------------
| Notification deep linking
|--------------------------------------------------------------------------
*/

/*
|--------------------------------------------------------------------------
| Tag marker visibility and positioning events
|--------------------------------------------------------------------------
*/

listenWindow(
    'resize',
    () => {
        if (
            modal.classList.contains(
                'hidden'
            )
        ) {
            return;
        }

        window.requestAnimationFrame(
            () => {
                repositionPhotoTagMarkers();
            }
        );
    }
);

tagToggleButton?.addEventListener(
    'click',
    () => {
        photoTagsVisible =
            !photoTagsVisible;

        renderPhotoTagVisibility();
    }
);

modal.addEventListener(
    'click',
    (event) => {
        const target =
            event.target;

        if (
            target instanceof Element
            && target.closest(
                '[data-photo-tag-marker-id]'
            )
        ) {
            return;
        }

        closeOpenTagLabels();
    }
);

/*
|--------------------------------------------------------------------------
| Notification deep linking
|--------------------------------------------------------------------------
*/

window.requestAnimationFrame(
    () => {
        openPhotoFromUrl();
    }
);
listenDocument(
    'click',
    (event) => {
        const target = event.target;

        if (!(target instanceof Node)) {
            return;
        }

        if (
            commentBody?.contains(target)
            || mentionResults?.contains(target)
        ) {
            return;
        }

        closeMentionResults();
    }
);

initializePhotoManagement(modal, { signal: lifecycle.signal, close: closeModal, pause: () => slideshow.pause() });
disposeModal = () => {
    lifecycle.abort();
    slideshow.stop();
    clearPreloadedPhotos();
    document.body.classList.remove('overflow-hidden');
    modal.classList.add('hidden');
    if (image) image.src = '';
    // Livewire snapshots the departing DOM; retain the viewer in that snapshot.
    if (modalHome.isConnected) modalHome.replaceWith(modal);
    else modal.remove();
};
};



if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeFestivalPhotoModal
    );
} else {
    initializeFestivalPhotoModal();
}

document.addEventListener('livewire:navigated', initializeFestivalPhotoModal);
document.addEventListener('livewire:navigating', () => {
    disposeModal();
    activeModal = null;
});
